export default {
    Invoice: {
        titleDetail: 'Chi tiết hóa đơn',
        titlePreviewPdf: 'Xem trước hóa đơn PDF',
        Title: 'Hóa đơn đầu vào',
        TitleDelete: 'Hóa đơn đã xóa',
        SellUnit: 'ĐƠN VỊ BÁN HÀNG',
        TaxCode: 'Mã số thuế:',
        Address: 'Địa chỉ:',
        BuyUnit: 'ĐƠN VỊ MUA HÀNG',
        InvoiceInfo: 'THÔNG TIN HÓA ĐƠN',
        TemplateNoTitle: 'Mẫu số:',
        OrganizationUnit: 'Đơn vị:',
        Series: 'Ký hiệu:',
        InvoiceNoTitle: 'Số hóa đơn:',
        InvoiceDateTitle: 'Ngày hóa đơn:',
        PublishedDate: 'Ngày phát hành:',
        SignedDate: 'Ngày ký:',
        PaymentInfo: 'THÔNG TIN THANH TOÁN',
        TotalMoney: 'Tổng tiền hàng:',
        TotalAmountWithoutVat: 'Tổng tiền trước thuế:',
        TotalVATAmount: 'Tổng thuế GTGT',
        TotalAmountTitle: 'Tổng tiền thanh toán:',
        WarningCheck: 'Vui lòng kiểm tra và đối chiếu lại với số tiền phải thanh toán trên tệp thể hiện HĐĐT',
        CheckResult: isreceipt => `Kết quả kiểm tra ${!isreceipt ? 'hóa đơn' : 'biên lai'}`,
        CheckLogic: 'Kiểm tra về tính toán số liệu',
        ValidBuyerTaxCode: 'Đúng mã số thuế bên mua',
        InvalidBuyerTaxCode: 'MST bên mua không hợp lệ',
        ValidBuyerName: 'Đúng tên bên mua',
        InvalidBuyerName: 'Tên công ty bên mua không chính xác',
        ValidSellerSignature: 'Hóa đơn đã được ký điện tử',
        InvalidSellerSignature: 'Hóa đơn chưa được ký điện tử',
        ValidCertificate: 'Chữ ký điện tử hợp lệ',
        InvalidCertificate: 'Chữ ký điện tử không hợp lệ',
        InvalidSellerName: 'Bên bán nằm trong danh sách đối tượng rủi ro về thuế',
        ValidSellerName: 'Bên bán không nằm trong danh sách đối tượng rủi ro về thuế',
        InvalidInvoicePublish: 'Hóa đơn chưa đăng ký phát hành',
        ValidInvoicePublish: 'Hóa đơn đã được đăng ký phát hành',
        ResultDate: 'Kết quả kiểm tra tại ngày',
        SellerModifiedDate: 'Đối chiếu với dữ liệu CQT ngày ',
        ViewImgCheck: 'Xem hình ảnh tra cứu TBPH hóa đơn',
        ViewImgCheckRisk: 'Xem hình ảnh tra cứu doanh nghiệp rủi ro',
        SellerEInvoiceDeactivatedDetail: 'Ngày ký, MST nhà cung cấp giải pháp HĐĐT, số seri chứng thư đã đăng ký tạm ngừng sử dụng hóa đơn điện tử trên tờ khai 01/ĐKTĐ-HĐĐT',
        CheckTCT: 'Kiểm tra với hệ thống của Cơ quan Thuế',
        SendToEmail: `Bạn có thể gửi hóa đơn điện tử hoặc chuyển tiếp (forward) hóa đơn của bạn đến email `,
        SendEmail: 'Gửi email',
        SystemAutomatic: 'phần mềm tự động tra cứu và tải hóa đơn điện tử',
        UsedSystemEmailOrUpload: 'hệ thống sẽ tự động tra cứu và tải hóa đơn điện tử hoặc Upload file hóa đơn điện tử đã có ngay',
        Here: 'tại đây',
        UploadInvoiceNow: 'hoặc tải lên hóa đơn có sẵn phần mềm tự động tra cứu và tải hóa đơn điện tử.',
        InvoiceWaiting: 'Hóa đơn chờ kiểm tra',
        InvoiceChecked: 'Hóa đơn đã kiểm tra',
        InvoiceValid: 'Hóa đơn hợp lệ',
        InvoiceWarning: 'Hóa đơn cảnh báo',
        Export: 'Xuất khẩu',
        Download: 'Tải xuống',
        DownloadUltra: 'Tải hóa đơn hàng loạt',
        PrintUltra: 'In hóa đơn hàng loạt',
        DownloadUltraNoteRow0: 'Do số lượng dữ liệu lớn nên việc tải dữ liệu sẽ mất một vài phút.',
        DownloadUltraNoteRow1: 'Phần mềm sẽ hiển thị thông báo khi hoàn tất.',
        PrintUltraNoteRow0: 'Do số lượng dữ liệu lớn nên việc in dữ liệu sẽ mất một vài phút.',
        PrintUltraNoteRow1: 'Phần mềm sẽ hiển thị thông báo khi hoàn tất.',
        DownloadHasBackground: 'Hóa đơn không có hình nền trống đồng',
        DownloadHasBackgroundNote0: 'Tối ưu băng thông và tăng tốc tải xuống',
        DownloadHasBackgroundNote1: 'Gồm một liên kết tải xuống duy nhất',
        EmailLink: 'Email nhận liên kết tải xuống',
        DownloadUltraNoteRow0: 'Do số lượng dữ liệu lớn nên việc tải dữ liệu sẽ mất một vài phút.',
        DownloadUltraNoteRow1: 'Phần mềm sẽ hiển thị thông báo khi hoàn tất.',
        PrintUltraNoteRow0: 'Do số lượng dữ liệu lớn nên việc in dữ liệu sẽ mất một vài phút.',
        PrintUltraNoteRow1: 'Phần mềm sẽ hiển thị thông báo khi hoàn tất.',
        DownloadHasBackground: 'Hóa đơn không có hình nền trống đồng',
        DownloadHasBackgroundNote0: 'Tối ưu băng thông và tăng tốc tải xuống',
        DownloadHasBackgroundNote1: 'Gồm một liên kết tải xuống duy nhất',
        EmailLink: 'Email nhận liên kết tải xuống',
        EmailTitleInput: 'Email nhận liên kết tải xuống',
        EmailLinkPlaceholder: 'Mỗi email cách nhau bằng dấu "cách"',
        EmailLinkPlaceholder: 'Mỗi email cách nhau bằng dấu "cách"',
        SearchPlaceHolder: 'Nhập Số hóa đơn, Tên người bán, Mã số thuế người bán, Số chứng từ, Biển số xe, Ghi chú để tìm kiếm',
        SearchPlaceHolderTrash: 'Nhập Số hóa đơn, Tên người bán, Mã số thuế người bán để tìm kiếm',
        SearchPlaceHolder1: 'Nhập Số hóa đơn, Tên người bán, Mã số thuế người bán...',
        FilterInvoice: 'Lọc hóa đơn',
        FilterConnectTaxaxion: 'Bộ lọc',
        FromDate: 'Từ ngày',
        ToDate: 'Đến ngày',
        Status: 'Tình trạng hóa đơn',
        RiskStatus: 'Tình trạng rủi ro',
        AcceptInvoice: 'Trạng thái',
        Cancel: 'Hủy bỏ',
        Filter: 'Lọc',
        AddInvoice: 'Thêm hóa đơn',
        UploadInvoice: 'Tải lên',
        Upload: 'Upload',
        ViewGuide: 'Xem hướng dẫn',
        SellerName: 'Tên người bán',
        SellerTaxCode: 'Mã số thuế',
        SellerTaxCodeTrash: 'MST người bán',
        TooltipSellerTaxCodeTrash: 'Mã số thuế người bán',
        BuyerNameTrash: 'Tên người mua',
        BuyerTaxCodeTrash: 'MST người mua',
        TooltipBuyerTaxCodeTrash: 'Mã số thuế người mua',
        TotalAmount: 'Tổng tiền',
        InvoiceNo: 'Số hóa đơn',
        InvoiceDate: 'Ngày hóa đơn',
        ReceivedDate: 'Ngày nhận',
        TemplateNo: 'Mẫu số',
        MultipleAction: 'Thực hiện hàng loạt',
        KindImport: 'Chọn mẫu',
        ListImport: 'Chọn danh sách muốn xuất khẩu',
        ListInvoiceStatement: 'Chọn bảng kê muốn xuất khẩu',
        ListImportSelect: 'Danh sách xuất khẩu',
        ListInvoiceStatementSelect: 'Bảng kê xuất khẩu',
        SystemImport: 'Chọn phần mềm muốn nhập khẩu',
        FileType: 'Định dạng',
        SystemTypeImport: 'Phần mềm muốn nhập khẩu',
        BuyerValid: 'Đúng thông tin người mua',
        BuyerInvalid: 'Sai thông tin người mua',
        BuyerUnchecked: 'Thông tin người mua',
        BuyerUnknown: 'Không có thông tin người mua',
        BuyerMissSomeInfo: 'Không đủ thông tin người mua',
        BuyerAddressValid: 'Đúng địa chỉ người mua',
        BuyerAddressInvalid: 'Sai địa chỉ người mua',
        BuyerAddressUnchecked: 'Địa chỉ người mua',
        BuyerAddressUnknown: 'Không có địa chỉ người mua',
        BuyerAddressChecking: 'Đang kiểm tra địa chỉ người mua',
        BuyerNameValid: 'Đúng tên người mua',
        BuyerNameInvalid: 'Sai tên người mua',
        BuyerNameUnchecked: 'Tên người mua',
        BuyerNameChecking: 'Đang kiểm tra tên người mua',
        BuyerNameUnknown: 'Không có tên người mua',
        BuyerTaxCodeValid: 'Đúng mã số thuế người mua',
        BuyerTaxCodeInvalid: 'Sai mã số thuế người mua',
        BuyerTaxCodeUnchecked: 'Mã số thuế người mua',
        BuyerTaxCodeUnknown: 'Không có mã số thuế người mua',
        BuyerTaxCodeChecking: 'Đang kiểm tra mã số thuế người mua',
        BuyerTaxCodeUncheck: 'Không kiểm tra mã số thuế người mua',
        BuyerTaxCodeUncheckTooltip: 'Không kiểm tra do không có giá trị tham chiếu (đơn vị nhận hóa đơn không có Mã số thuế tại Cơ cấu tổ chức)',
        BuyerIdCardValid: 'Đúng căn cước công dân',
        BuyerIdCardInvalid: 'Sai căn cước công dân',
        BuyerIdCardUnchecked: 'Không kiểm tra căn cước công dân',
        BuyerIdCardUnknown: 'Không có căn cước công dân',
        BuyerIdCardUncheckedTooltip: 'Không kiểm tra do không có giá trị tham chiếu (đơn vị nhận hóa đơn không có CCCD chủ hộ tại Cơ cấu tổ chức)',
        BuyerIdCardNoCheck: 'Không kiểm tra căn cước công dân người mua',
        BuyerIdCardNoCheckTooltip: 'Không kiểm tra do không có giá trị tham chiếu. Đơn vị nhận hóa đơn chỉ có thông tin Mã số thuế tại Cơ cấu tổ chức',
        BuyerIdCardChecking: 'Đang kiểm tra căn cước công dân',
        SellerValid: 'Đúng thông tin người bán',
        SellerInvalid: 'Sai thông tin người bán',
        SellerUnchecked: 'Thông tin người bán',
        SellerUnknown: 'Không có thông tin người bán',
        SellerMissSomeInfor: 'Không đủ thông tin người bán',
        SellerAddressValid: 'Đúng địa chỉ người bán',
        SellerAddressInvalid: 'Sai địa chỉ người bán',
        SellerAddressUnchecked: 'Địa chỉ người bán',
        SellerAddressUnknown: 'Không có địa chỉ người bán',
        SellerAddressChecking: 'Đang kiểm tra địa chỉ người bán',
        BusinessLocationCriteria: 'Địa điểm kinh doanh',
        BusinessLocationValid: 'Đủ thông tin địa điểm kinh doanh',
        BusinessLocationInvalid: 'Thiếu thông tin địa điểm kinh doanh',
        BusinessLocationUnknown: 'Không có địa điểm kinh doanh',
        BusinessLocationInvalidTooltip: 'Thiếu thông tin địa điểm kinh doanh theo quy định tại',
        BusinessLocationAccepted: 'Chấp nhận thiếu thông tin địa điểm kinh doanh',
        BusinessLocationAccept: 'Chấp nhận thiếu thông tin này',
        BusinessLocationUnaccept: 'Bỏ chấp nhận thiếu thông tin này',
        BusinessLocationValidTooltip: 'Đủ thông tin địa điểm kinh doanh theo quy định tại',
        SellerNameValid: 'Đúng tên người bán',
        SellerNameInvalid: 'Sai tên người bán',
        SellerNameUnchecked: 'Tên người bán',
        BuyerAddress: 'Địa chỉ nguời mua',
        BuyerTaxCode: 'Mã số thuế người mua',
        BuyerNameResult: 'Tên người mua',
        SellerNameUnknown: 'Không có tên người bán',
        SellerTaxCodeUnKnown: 'Không có mã số thuế người bán',
        NoSellerTaxCodeXml: 'Không có thông tin MST trên XML của hóa đơn',
        NoSellerNameXml: 'Không kiểm tra được thông tin tên người bán do trên XML hóa đơn không có thông tin MST người bán',
        NoSellerAddressXml: 'Không kiểm tra được thông tin địa chỉ người bán do trên XML hóa đơn không có thông tin MST người bán',
        NonSellerAddressInfo: 'Không có thông tin địa chỉ',
        NonSellerNameInfo: 'Không có thông tin tên',
        SellerNameChecking: 'Đang kiểm tra tên người bán',
        Seller: 'Người bán',
        SellerActiveStatusValid: 'Người bán đang hoạt động',
        SellerActiveStatusInvalid: 'Người bán ngừng hoạt động',
        SellerActiveStatusUnchecked: 'Trạng thái hoạt động người bán',
        SellerActiveStatusUnknown: 'Không có thông tin để kiểm tra tình trạng hoạt động người bán',
        SellerActiveStatusValidChecked: 'Trạng thái hoạt động người bán được chấp nhận hợp lệ',
        SignatureStatusValid: 'Chữ ký điện tử hợp lệ',
        SignatureStatusInvalid: 'Chữ ký điện tử không hợp lệ',
        SignatureStatusValidChecked: 'Chữ ký điện tử được chấp nhận hợp lệ',
        SignatureStatusUnchecked: 'Chữ ký điện tử',
        SignatureStatusUnknown: 'Không đủ thông tin chữ ký điện tử',
        SellerSignatureStatusValid: 'Chữ ký điện tử NCC hợp lệ',
        NoCheckSignatureByBTH: 'Không kiểm tra chữ ký điện tử NCC do là hóa đơn gửi theo BTH không có xml',
        SellerSignatureStatusInvalid: 'Chữ ký điện tử NCC không hợp lệ',
        SellerSignatureStatusUnchecked: 'Chữ ký điện tử NCC',
        SellerSignatureStatusUnknown: 'Không đủ thông tin chữ ký điện tử NCC',
        SellerSignatureStatusMissSomeInfo: 'Không đủ thông tin chữ ký điện tử NCC',
        SellerSignatureStatusValidChecked: 'Chữ ký điện tử NCC được chấp nhận hợp lệ',
        TaxaxionSignatureUnchecked: 'Chữ ký điện tử Cơ quan thuế',
        TaxaxionSignatureValid: 'Đã được ký bởi Cơ quan thuế',
        TaxaxionSignatureInvalid: 'Đã được ký bởi Cơ quan thuế',
        TaxaxionSignatureUnknown: 'Chưa được ký bởi Cơ quan thuế',
        TaxaxionSignatureValidChecked: 'Chữ ký điện tử Cơ quan thuế được chấp nhận hợp lệ',
        PublishedValidPrimary: 'Hóa đơn đã thông báo phát hành từ Công ty/Tổng Công ty',
        PublishedValid: 'Hóa đơn đã thông báo phát hành',
        PublishedInvalid: 'Hóa đơn chưa thông báo phát hành',
        PublishedUnchecked: 'Hệ thống đang kiểm tra và sẽ trả về kết quả sau ít phút',
        PublishedUnknown: 'Không có thông tin để kiểm tra thông báo phát hành hóa đơn của người bán',
        InvoicePublishedValid: 'Mẫu số ký hiệu đã được thông báo phát hành',
        InvoicePublishedInvalid: 'Mẫu số ký hiệu chưa được thông báo phát hành',
        InvoicePublishedUnchecked: 'Mẫu số ký hiệu',
        InvoicePublishedUnknown: 'Không có thông tin mẫu số ký hiệu',
        InvoiceNoValid: 'Số hóa đơn thuộc khoảng hóa đơn thông báo phát hành (từ số, đến số)',
        InvoiceNoInvalid: 'Số hóa đơn không thuộc khoảng hóa đơn thông báo phát hành (từ số, đến số)',
        InvoiceNoUnchecked: 'Số hóa đơn',
        InvoiceNoUnknown: 'Không có thông tin số hóa đơn',
        InvoiceDateValid: 'Ngày hóa đơn hợp lệ',
        InvoiceDateInvalid: 'Ngày hóa đơn nhỏ hơn ngày bắt đầu sử dụng',
        InvoiceDateUnchecked: 'Ngày hóa đơn',
        InvoiceDateUnknown: 'Không có thông tin ngày hóa đơn',
        SignedDateEqInvoiceDateValid: 'Ngày ký trùng ngày hóa đơn',
        SignedDateEqInvoiceDateInvalid: 'Ngày ký khác ngày hóa đơn',
        SignedDateEqInvoiceDateUnchecked: 'Ngày ký',
        SignedDateEqInvoiceDateUnknown: 'Không có thông tin ngày ký',
        CertificateOwnerValid: 'Thông tin thuê bao chứng thư số hợp lệ',
        CertificateOwnerValidChecked: 'Thông tin thuê bao chứng thư số hợp lệ',
        CertificateOwnerInvalid: 'Thông tin thuê bao chứng thư số không hợp lệ',
        CertificateOwnerUnchecked: 'Thông tin thuê bao chứng thư số chưa kiểm tra',
        CertificateOwnerUnknown: 'Không có MST người bán trong thông tin CTS',
        SignedDateValid: 'Chứng thư số còn hiệu lực',
        SignedDateValidChecked: 'Chứng thư số còn hiệu lực',
        SignedDateInvalid: 'Ngày ký không nằm trong khoảng hiệu lực của chứng thư số',
        SignedDateUnchecked: 'Ngày ký',
        SignedDateUnknown: 'Không có thông tin ngày hiệu lực chứng thư số với ngày ký hóa đơn',
        DataWasModifiedValid: 'File XML chưa bị sửa đổi sau khi ký',
        DataWasModifiedValidChecked: 'File XML chưa bị sửa đổi sau khi ký',
        DataWasModifiedInvalid: 'File XML bị sửa đổi sau khi ký',
        DataWasModifiedUnchecked: 'File XML bị sửa đổi sau khi ký',
        DataWasModifiedUnknown: 'Không có thông tin để kiểm tra file XML bị sửa đổi sau khi ký hay không',
        CertificateValid: 'Chứng thư số hợp lệ',
        CertificateInvalid: 'Nhà cung cấp chứng thư số không nằm trong danh sách được cấp phép',
        CertificateUnknown: 'Không xác định được trạng thái hợp lệ của CTS. Vui lòng liên hệ với người bán và NCC CTS để được hỗ trợ.',
        CertificateMissSomeInfo: 'Chữ ký điện tử không đủ thông tin',
        CertificateRecall: 'Chứng thư số bị thu hồi ngày: ',
        CertificateSuspended: 'Chứng thư số bị tạm khóa từ ngày ',
        TaxRiskStatusValid: 'Người bán không rủi ro tại thời điểm phát hành hóa đơn',
        TaxRiskStatusInvalid: 'Người bán đang rủi ro tại thời điểm phát hành hóa đơn',
        TaxRiskStatusUnchecked: 'Hệ thống đang kiểm tra và sẽ trả về kết quả sau ít phút',
        TaxRiskStatusUnknown: 'Chưa đủ thông tin để kết luận người bán có rủi ro tại thời điểm phát hành hóa đơn không',
        TaxRiskStatusValidChecked: 'Người bán được chấp nhận không rủi ro về thuế tại thời điểm phát hành hóa đơn',
        ExportInvoice: 'Xuất khẩu hóa đơn',
        ExportAccountingHere: 'Tại đây bạn có thể xuất khẩu vào phần mềm kế toán',
        Uploadding: 'Đang tải lên',
        Invoice: 'hóa đơn',
        Failed: 'thất bại',
        Success: 'thành công',
        FileUnsupport: 'File không được hỗ trợ',
        FileDuplicated: 'Hóa đơn bị trùng',
        FileExtensions: 'Định dạng file không được hỗ trợ. Vui lòng chọn file có định dạng xml, zip.',
        FileUploadFailed: 'Hóa đơn tải lên không thành công',
        TourGuideStep1Title: 'Bộ lọc',
        TourGuideStep1Content: 'Lọc các giá trị trên danh sách hóa đơn.',
        TourGuideStep2Title: 'Chọn hóa đơn',
        TourGuideStep2Content: 'Chọn hàng loạt hóa đơn để thực hiện nhanh các tác vụ khác nhau như: Tải xuống, In, Gắn nhãn, Xuất khẩu,...',
        TourGuideStep3Title: 'Thực hiện tác vụ hàng loạt',
        TourGuideStep3Content: 'Sau khi chọn các hóa đơn bạn có thể thực hiện tác vụ với các hóa đơn đã chọn.',
        TourGuideStep4Title: 'Xuất khẩu',
        TourGuideStep4Content: 'Xuất khẩu danh sách, bảng kê, dữ liệu nhập khẩu vào các phần mềm kế toán.',
        TourGuideStep1: 'MISA meInvoice hỗ trợ bạn xuất dữ liệu ra tệp excel để nhập vào các phần mềm kế toán phổ biến.',
        TourGuideStep2: 'Bạn có thể chọn hóa đơn muốn lưu trữ hoặc xuất khẩu tại đây.',
        TourGuideStep3: 'Sau khi chọn hóa đơn bạn có thể tải xuống lưu trữ hoặc xuất khẩu để nhập vào phần mềm kế toán.',
        Business: 'Ngành nghề kinh doanh',
        OfficeRepresentive: 'Văn phòng đại diện',
        EmptyBusinessInfo: 'Không có thông tin ngành nghề kinh doanh',
        EmptyOfficeRepresentive: 'Không có thông tin văn phòng đại diện',
        EmptySearchInvoice: 'Không tìm thấy thông tin hóa đơn theo điều kiện lọc, vui lòng thử lại',
        EmptyInvoiceForMe: 'Không có hóa đơn nào',
        FileCanDownload: 'Bạn có thể tải lên file hóa đơn tại đây.',
        CertificateInfo: 'Thông tin chứng thư',
        CertificateIssuer: 'Nhà phát hành chứng thư:',
        CertificateIssueTo: 'Đơn vị ký:',
        CertificateValidFrom: 'Ngày bắt đầu hiệu lực:',
        CertificateValidTo: 'Ngày kết thúc hiệu lực:',
        CertificateSignedDate: isreceipt => `Ngày ký ${!isreceipt ? 'hóa đơn:' : 'biên lai:'}`,
        AddressInInvoice: 'Địa chỉ trên hóa đơn',
        AddressInSystem: 'Địa chỉ kiểm tra trên website của Cơ quan thuế',
        AddressCheck: 'Địa chỉ kiểm tra',
        SellerNameInInvoice: '',
        Stick: 'Nhãn dán',
        NewStick: 'Nhãn mới',
        EditStick: 'Sửa nhãn',
        AddStick: 'Gắn nhãn',
        AddStickMany: 'Gắn nhãn hàng loạt',
        RemoveStickMany: 'Gỡ nhãn',
        SettingStick: 'Quản lý nhãn',
        NoteInvoice: 'Ghi chú hóa đơn',
        NoteInvoiceList: 'Ghi chú các hóa đơn',
        NoteInvoiceSuccess: 'Danh sách hóa đơn đã có ghi chú',
        AttachInvoice: 'Tệp đính kèm',
        UploadAttachInvoice: 'Tải lên tệp',
        DownloadAttachInvoice: 'Tải xuống tệp',
        OnlyAttachments: 'Chỉ tệp đính kèm',
        AllFilesWithAttachments: 'Tất cả (Tệp đính kèm, Bản thể hiện, XML)',
        SendReportToMisa: 'Phản hồi cho MISA lỗi kiểm tra',
        SendReport: 'Phản hồi kết quả kiểm tra cho nhà phát triển (MISA)',
        InbotInvoiceList: 'Danh sách hóa đơn',
        InvoiceLoadingTab: 'Hóa đơn đang tải',
        InputInvoiceTab: 'Hóa đơn đầu vào',
        InputInvoiceTabTooltip: 'Bao gồm các hóa đơn đã được hệ thống tiếp nhận và xử lý thành công, như hóa đơn NSD tự tải lên hoặc gửi qua email, hóa đơn tải thành công từ CQT hoặc Nhà cung cấp. Hóa đơn đang trong quá trình tải từ CQT được hiển thị tại danh sách Hóa đơn đang tải.',
        InvoiceLoadingTabTooltip: 'Bao gồm các hóa đơn đang tải, tải lỗi hoặc không được tải từ CQT do thiết lập của người sử dụng. Xem thông tin tại cột Trạng thái và Mô tả chi tiết.',
        OutInvoiceTabTooltip: 'Bao gồm các hóa đơn đã được hệ thống tiếp nhận và xử lý thành công, như hóa đơn NSD tự tải lên hoặc hóa đơn tải thành công từ CQT. Hóa đơn đang trong quá trình tải từ CQT được hiển thị tại danh sách Hóa đơn đang tải.',
        OutInvoiceLoadingLastSync: 'Tính đến',
        ReloadLoadingInvoice: 'Tải lại',
        OutInvoiceLoadingBanner: 'Danh sách hóa đơn đầu ra đang hoàn tất quá trình tải dữ liệu từ CQT.',
        OutInvoiceLoadingDisconnected: 'Mất kết nối Cơ quan thuế',
        OutInvoiceLoadingDisconnectedDescription: 'Vui lòng nhấn Kết nối CQT để tiếp tục đồng bộ hóa đơn đầu ra từ Cơ quan thuế về chương trình.',
        LoadingLearnMore: 'Tìm hiểu thêm',
        InvoiceDateRange: 'Ngày hóa đơn',
        InvoiceLoadingBanner: 'Danh sách hóa đơn đang hoàn tất quá trình tải dữ liệu từ CQT.',
        NoInvoiceLoadingData: 'Chưa có dữ liệu',
        NoInvoiceLoadingDataDescription: 'Chưa có hóa đơn mới chờ đồng bộ từ CQT',
        LoadingStatus: 'Trạng thái',
        LoadingDescription: 'Mô tả chi tiết',
        SellerTaxCode: 'MST người bán',
        SellerName: 'Tên người bán',
        InvoiceTemplate: 'Mẫu số',
        InvoiceSeries: 'Ký hiệu',
        LoadingTotalVatAmount: 'Tổng tiền thuế',
        LoadingTotalAmount: 'Tổng tiền',
        InvoiceInbot: 'Bảng kê hóa đơn',
        LoadingStatusDownloading: 'Đang tải',
        LoadingStatusIgnored: 'Bỏ qua',
        LoadingStatusFailed: 'Tải thất bại',
        LoadingStatusDuplicated: 'Hóa đơn trùng',
        LoadingDescDownloading: 'Đang tải dữ liệu từ CQT',
        LoadingDescIgnored: 'Thiết lập không tải về hóa đơn',
        LoadingDescFailed: 'Không thể kết nối đến dữ liệu của CQT',
        LoadingDescDuplicated: orgName => `Hóa đơn đã tồn tại ở đơn vị ${orgName}`,
        DeclarationList: 'Danh sách tờ khai',
        ImportInApp: 'Nhập khẩu vào PM kế toán',
        SelectOrganization: 'Chọn cơ cấu tổ chức',
        AccountingDate: 'Ngày hạch toán',
        TotalSTC: 'Thuế TTĐB:',
        TotalDiscountAmount: 'Tiền chiết khấu:',
        TotalOther: 'Các khoản thu hộ, chi hộ khác:',
        NoInformation: 'Không có thông tin',
        TaxAuthorityCreatedDate: 'Ngày gửi đến CQT',
        DiscountInvalid: 'Là hóa đơn chiết khấu không đúng quy định',
        DiscountInvalidTooltip: 'Hóa đơn để chiết khấu không đúng quy định về chiết khấu thương mại tại khoản 13 Điều 1 Nghị định 70 sửa đổi, bổ sung điểm b khoản 4 Điều 19 Nghị định 123/2020/NĐ-CP.',
        MoreVATAmount: 'Thuế GTGT',
        VatAmount: 'Tiền thuế GTGT',
        DateInvoice: 'Ngày hóa đơn',
        DateAccountingDate: 'Ngày hạch toán',
        DateReceived: 'Ngày vào hệ thống',
        KindAccounting: 'Tình trạng hạch toán',
        KindDateOption: 'Ngày',
        Format: 'Định dạng',
        MoveInvoice: 'Điều chuyển hóa đơn/biên lai đến',
        TypeInvoiceReceive: 'Nguồn hóa đơn',
        InvoiceLogicSucess: 'Hóa đơn chính xác về tính toán số liệu',
        InvoiceLogicFail: 'Hóa đơn chưa chính xác về tính toán số liệu',
        InvoiceExistTCT: 'Kiểm tra trên hệ thống của Cơ quan Thuế',
        InvoiceExistAccept: 'Hóa đơn đã được chấp nhận tồn tại trên hệ thống Cơ quan thuế',
        InvoiceExistSucess: 'Hóa đơn đã tồn tại trên hệ thống tra cứu Cơ quan thuế tại thời điểm kiểm tra',
        InvoiceExistFail: 'Hóa đơn chưa tồn tại trên hệ thống tra cứu Cơ quan thuế tại thời điểm kiểm tra',
        InvoiceExistChecking: 'Hệ thống đang kiểm tra và sẽ trả về kết quả sau ít phút',
        InvoiceExistCheckingV2: `Chưa xác định hóa đơn có tồn tại trên thuế hay không`,
        InvoiceExistHasCode: 'Hóa đơn đã được cấp mã',
        InvoiceAdjustedSucess: 'Hóa đơn thay thế/điều chỉnh hợp lệ',
        InvoiceAdjustedFail: 'Hóa đơn thay thế/điều chỉnh vi phạm',
        InvoiceAdjustedCore: 'Chỉ được điều chỉnh cho hóa đơn gốc',
        InvoiceAdjustedInfo: (tempNo, seri, invNo) =>
            `Hóa đơn gốc đã được điều chỉnh bởi hóa đơn có mẫu số <span class='font-bold'>${tempNo}</span>, ký hiệu <span class='font-bold'>${seri}</span>, số hóa đơn <span class='font-bold'>${invNo}</span>`,
        TotalFee: 'Tổng tiền phí:',
        AttachFile: 'Tệp đính kèm',
        StatusFilter: 'Trạng thái hóa đơn',
        PaymentWarning: 'Ngày nhắc hạn thanh toán',
        PaymentOutOfDate: 'Ngày quá hạn thanh toán',
        ChangeStatusInvoiceOnSystemDate: 'Ngày phát hiện đổi trạng thái',
        ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
        PaymentNotPay: 'Ngày HĐ chưa thanh toán',
        NumberInvoiceExportOver: number => `Xuất tối đa ${number} bản ghi trên 1 lần`,
        IssueDate: 'Ngày cấp mã:',
        Approved: 'Đã duyệt',
        RefuseApprove: 'Từ chối duyệt',
        ApproveWait: 'Chờ duyệt',
        FullPayment: 'Thanh toán toàn phần',
        ExpriedPayment: 'Đến hạn thanh toán',
        PaymentYet: 'Chưa thanh toán',
        PartialPayment: 'Thanh toán một phần',
        OverduePayment: 'Quá hạn thanh toán',
        Exactly: 'Chính xác',
        NotExactly: 'Chưa chính xác',
        WaitChecking: 'Chưa kiểm tra',
        SelectFileDownload: 'Chọn định dạng của hóa đơn',
        EachInvoiceIsFolder: 'Mỗi hóa đơn là 1 thư mục',
        MergeInvoicesIntoOneFolder: 'Gộp tất cả hóa đơn vào 1 thư mục',
        ValueAddedEInvoice: 'Hóa đơn giá trị gia tăng',
        VatInvoice: 'Hóa đơn giá trị gia tăng',
        EInvoice: 'Hóa đơn có mã, không mã',
        GeneratorFromCashRegister: 'Hóa đơn khởi tạo từ máy tính tiền',
        SaleEInvoice: 'Hóa đơn điện tử bán hàng',
        SaleInvoice: 'Hóa đơn bán hàng',
        EInvoiceSalePublicProperty: 'Hóa đơn bán tài sản công',
        NationalReserveSaleEInvoice: 'Hóa đơn bán hàng dự trữ quốc gia',
        EInvoiceTicket: 'Hóa đơn khác (tem, vé, thẻ)',
        CommercialInvoice: 'Hóa đơn thương mại',
        DeliveryBill: 'Phiếu xuất kho',
        ConcurrentlyInternalShip: 'Phiếu xuất kho kiêm vận chuyển nội bộ',
        GoodsSaleByAgent: 'Phiếu xuất kho hàng gửi bán đại lý',
        AlertWrongData: 'Chưa chính xác về tính toán số liệu',
        SellerEInvoiceDeactivated: 'Người bán đăng ký tạm ngừng sử dụng HĐĐT',
        TotalReductionNotTax: 'Tổng giảm trừ không chịu thuế:',
        TotalReductionOther: 'Tổng giảm trừ khác:',
        OutOfTime: 'Thuế suất 8% ngoài thời gian giảm thuế',
        AcceptTax: 'Đã chấp nhận thuế suất',
        AlertRiskBusiness: isReceipt => `Có rủi ro về  ${isReceipt ? 'biên lai' : 'hóa đơn'} theo công văn của CQT`,
        AlertRegulatoryDocument: (document, isReceipt) =>
            `Có rủi ro về ${isReceipt ? 'biên lai' : 'hóa đơn'} theo Công văn ${document}`,
        AlrttRisk06: isReceipt => `Có rủi ro về ${isReceipt ? 'biên lai' : 'hóa đơn'}`,
        TooltipRisk: isReceipt =>
            `Có rủi ro về ${
				isReceipt ? 'biên lai' : 'hóa đơn'
			} do có tình trạng hoạt động là "NNT không hoạt động tại địa chỉ đã đăng ký" tại ngày ${
				isReceipt ? 'biên lai' : 'hóa đơn'
			}`,
        HistoryActiveStatus: 'Lịch sử tình trạng hoạt động',
        NotificationRemoveHistoryActiveStatus: 'Hệ thống <span style="color: #F04438;font-weight: 700">chưa thể xác định chính xác</span> ngày thay đổi tình trạng hoạt động của nhà cung cấp do yêu cầu tuân thủ Nghị định 13/2023/NĐ-CP về <span style="color: #212529;font-weight: 700">bảo vệ dữ liệu cá nhân</span> và <span style="color: #212529;font-weight: 700">quy định bảo mật thông tin</span> của Cục Cảnh sát quản lý hành chính về trật tự xã hội (C06).',
        NumberInvoice: 'Số lượng hóa đơn',
        ViewInvoice: 'Trạng thái xem hóa đơn',
        UpdateStatus: 'Cập nhật trạng thái',
        UpdateStatusOut: 'Kiểm tra lại',
        SearchInfoTaxPayer: 'Tra cứu thông tin người nộp thuế',
        ViewInvoieRelative: 'Xem hóa đơn liên quan',
        RelativeInvoice: 'Hóa đơn liên quan',
        NotPermissonInvoice: 'Không có quyền xem hóa đơn',
        ContactAdminToView: 'Vui lòng liên hệ quản trị viên để tiếp tục xem',
        OriginalInvoice: 'Hóa đơn gốc',
        DeletedFromList: 'Đã bị xóa khỏi danh sách hóa đơn',
        SummaryNotDownload: 'Hóa đơn theo bảng tổng hợp đã được thiết lập không tải về',
        NotifyStopUse: 'Ký hiệu mẫu số hóa đơn, ký hiệu hóa đơn, số hóa đơn, ngày lập hóa đơn có trong thông báo ngừng sử dụng hóa đơn',
        NotifyInvoiceDateStopPeriod: 'Ngày lập hóa đơn thuộc thời gian ngừng sử dụng hóa đơn điện tử',
        CheckingResult: {
            NoInvoiceNumber: 'Không có số hóa đơn',
            NoReceiptNumber: 'Không có số biên lai',
            InvoiceNoInvalid: length => `Số hóa đơn vượt quá ${length} chữ số`,
            ReceiptNoInvalid: length => `Số biên lai vượt quá ${length} chữ số`,
            InvoiceDateInvalid: 'Không có ngày hóa đơn',
            ReceiptDateInvalid: 'Không có ngày biên lai',
            SignatureDateInvalid: 'Không có ngày ký',
            CcyCodeInvalid: 'Không có đơn vị tiền tệ',
            ExchangeRateInvalid: 'Không có tỷ giá',
            StatementDateInvoiceRealtedInvalid: 'Không có ngày bảng kê của hóa đơn liên quan',
            TemplateNoInvoiceRealtedInvalid: 'Không có mẫu số của hóa đơn liên quan',
            SeriesInvoiceRealtedInvalid: 'Không có ký hiệu của hóa đơn liên quan',
            InvoiceNoRealtedInvalid: 'Không có số hóa đơn liên quan',
            InvoiceDateRealtedInvalid: 'Không có ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
            TemplateNoReceiptRealtedInvalid: 'Không có mẫu số của biên lai liên quan',
            SeriesReceiptRealtedInvalid: 'Không có ký hiệu của biên lai liên quan',
            ReceiptNoRealtedInvalid: 'Không có số biên lai liên quan',
            ReceiptDateRealtedInvalid: 'Không có ngày lập biên lai có liên quan (Ngày lập biên lai bị thay thế/điều chỉnh)',
            ItemNameInvalid: 'Không có tên hàng hóa, dịch vụ',
            ReceiptItemNameInvalid: 'Không có tên loại phí',
            TotalAmountInvalid: 'Không có thành tiền',
            ReceiptTotalAmountInvalid: 'Không có tiền phí',
            VatRateInvalid: 'Không có thuế suất',
            VatRatePaymentInvalid: 'Thiếu thông tin tổng hợp theo mức thuế suất',
            PaymentTotalAmountNumberInvalid: 'Không có tổng tiền thanh toán bằng số',
            PaymentTotalAmountWordInvalid: 'Không có tổng tiền thanh toán bằng chữ',
            TotalAmountThan: text => `Thanh toán tiền mặt ${text != '' ? `với hóa đơn ≥ ${text}tr` : ''}`
		},
		MultipleTaxCodeNotice:
			'Theo <span style="color: #00AAB7">Điều 84 Nghị định 01/2021/NĐ-CP</span>, HKD có thể đăng ký nhiều MST riêng ở các địa chỉ khác nhau, nên hệ thống hiển thị để phân biệt rõ ràng.',
		OldTaxCode: 'MST (cũ)',
		ViewHistoryStatus: 'Xem lịch sử tình trạng hoạt động'
	},
	// Popup "Bạn có biết: Có thể rút ngắn Mẫu hóa đơn mặc định?" (PBI 677171)
	ShortenTemplateGuide: {
		Title: 'Bạn có biết: Có thể rút ngắn Mẫu hóa đơn mặc định?',
		Description:
			'Nhằm đáp ứng đầy đủ các mức thuế suất theo Quyết định số 1233/QĐ-CT của Cục thuế, hệ thống hiện hỗ trợ thêm 3 mức thuế suất (',
		VatFinancialLease: 'Thuế suất cho thuê tài chính',
		VatKTPVDC: 'Không thuộc phạm vi điều chỉnh của Luật Thuế',
		VatKTGTT: 'Không tính vào giá tính thuế GTGT',
		DescriptionTail: ') trên Mẫu mặc định.',
		AlertText: 'Vì vậy, kích thước mẫu hóa đơn dài hơn trước.',
		AlertTextLead: 'Quý khách có thể',
		ViewGuide: 'xem hướng dẫn thiết lập mẫu hóa đơn',
		AlertTextTail: 'để phù hợp với nhu cầu in ấn',
		Here: 'tại đây',
		DontShowAgain: 'Không hiển thị lại',
		Understood: 'Đã hiểu'
	},
	Upload: {
		Note: 'Bạn có biết? Bạn có thể nhận hóa đơn thông qua email ',
		CheckedSuccess: 'Đã kiểm tra',
		UploadFailed: 'Không đọc được HĐ',
		CheckedDuplicate: 'Hóa đơn trùng',
		CheckedFailed: 'HĐ không hợp lệ',
		CheckedProgress: 'Đang kiểm tra HĐ',
		UploadStarted: 'Đang tải lên',
		Expired: 'Hết hạn sử dụng',
		OutOfQuantity: 'Hết hóa đơn sử dụng',
		Uncompleted: 'HĐ chưa kiểm tra được hết các chỉ tiêu',
		Error: 'Tệp tin không hợp lệ',
		Draft: 'Bản nháp',
		InvalidFormat: 'Định dạng không được hỗ trợ',
		MaxLength: 'Dung lượng file vượt quá 5MB',
		FileFailedProcessed: 'Xử lý tệp thất bại',
		Delete: 'Hóa đơn xóa bỏ',
		// US1 — Gửi hóa đơn không đọc được cho nhà phát triển
		SendToDeveloper: 'Gửi cho nhà phát triển',
		AlreadySentToDeveloper: 'Đã gửi',
		SendToDeveloperConfirmTitle: 'Gửi hóa đơn cho nhà phát triển',
		SendToDeveloperConfirmBody:
			'Hóa đơn của bạn sẽ được gửi cho nhà phát triển để nghiên cứu và cải tiến trong thời gian sớm nhất.',
		BtnSendToDeveloper: 'Gửi cho nhà phát triển',
		// US2 — Thành công và gửi thêm
		SendToDeveloperSuccessTitle: 'Gửi hóa đơn cho nhà phát triển thành công',
		SendToDeveloperSuccessBody: 'Chương trình đã ghi nhận tài liệu và sẽ tiến hành nghiên cứu để cải tiến.',
		BtnSendMoreInvoices: 'Gửi thêm hóa đơn',
		SendMoreInvoicesTitle: 'Gửi thêm hóa đơn cho nhà phát triển',
		SendMoreInvoicesHint: 'hoặc kéo và thả tệp vào đây',
		SendMoreInvoicesFormat: 'Định dạng PDF, ZIP (Tối đa 5MB)',
		BtnContinue: 'Tiếp tục',
		SendMoreInvoicesNoFileTitle: 'Chưa tải tệp lên',
		SendMoreInvoicesNoFileBody: 'Vui lòng tải lên tệp của bạn trước khi nhấn “Tiếp tục”.',
		SendMoreSuccessTitle: 'Gửi hóa đơn thành công',
		SendMoreSuccessBody:
			'Hóa đơn của bạn sẽ được gửi cho nhà phát triển để nghiên cứu và cải tiến trong thời gian sớm nhất.',
		// US3 — Gửi thất bại
		SendToDeveloperFailedTitle: 'Gửi hóa đơn thất bại',
		SendToDeveloperFailedBody:
			'Gửi hóa đơn cho nhà phát triển thất bại. Hệ thống gặp sự cố kỹ thuật. Vui lòng thử lại sau.',
		BtnResendInvoice: 'Gửi lại hóa đơn',
		BtnCancel: 'Hủy bỏ',
		BtnClose: 'Đóng',
		UnreadableInvoiceTab: num => `Không đọc được HĐ (${num})`,
		UploadSelectFile: 'Chọn tệp',
		UploadDragDrop: 'Chọn tệp hoặc kéo và thả...',
		UploadFormatHint: 'PDF, zip (tối đa 5MB)',
		UploadSuccessText: 'Tải tệp thành công hoặc',
		UploadSelectAnother: 'Chọn tệp khác',
		MaxFile5MbUpload: 'Dung lượng file tối đa gửi lên chương trình là 5mb. Vui lòng kiểm tra lại!'
	},

	ConnectInvoices: {
		DateConnect: 'Ngày hóa đơn',
		TotalInvoice: 'Tổng đã tải được',
		TotalInvoiceTaxaxion: 'Tổng HĐ CQT',
		TotalDownloadSuccess: 'Tải thành công',
		TotalDownloadFail: 'Tải thất bại',
		TotalInvoiceSuccess: 'HĐ đã xử lý',
		TotalInvoiceDuplicate: 'HĐ trùng',
		TotalInvoiceProcessFail: 'HĐ không đọc được',
		TotalInvoiceIgnore: 'Bỏ qua',
		TotalInvoiceProcessing: 'Đang tải',
		Processed: 'Đã xử lý',
		TotalInvoiceTaxaxionTooltip: 'Dữ liệu cũ chưa có số liệu',
		TitleTotalInvoiceTaxaxionTooltip: 'Tổng HĐ trên CQT tại thời điểm đồng bộ gần nhất',
		TotalInvoiceifference: 'Tổng chưa tải được'
	},

	OutInvoice: {
		Customer: 'Tên người mua',
		TaxCode: 'MST người mua',
		Address: 'Địa chỉ người mua',
		StatusInvoice: 'Trạng thái hóa đơn',
		SearchPlaceHolder: 'Nhập Số hóa đơn, Tên người mua, MST người mua để tìm kiếm',
		Series: 'Ký hiệu',
		ProcessOutInvoice: 'Xử lý hóa đơn đầu ra',
		TaxaxionCode: 'Mã cơ quan thuế',
		UploadSuccess: 'Thành công',
		NotNeedCheck: 'Hoá đơn NCC nước ngoài',
		TooltipNotNeedCheck: 'Hóa đơn nhà cung cấp nước ngoài'
	},

	InvoiceManagement: {
		InvoiceInbot: 'Hóa đơn đầu vào',
		InvoiceInbotThirdParty: 'Hóa đơn',
		InvoiceTrash: 'Hóa đơn đã xóa',
		AddInvoice: 'Thêm hóa đơn',
		Export: 'Xuất khẩu',
		SuggestionDownload: 'Bạn có thể tải file hóa đơn với định dạng xml/inv/pdf tại đây.',
		SendMailAccount: 'Gửi email hóa đơn đến tài khoản',
		ViewGuide: 'Xem hướng dẫn',
		NotData: 'Không có dữ liệu',
		CopyEmailSuccess: 'Sao chép email thành công',
		TooltipExport: 'Xuất khẩu danh sách, bảng kê, dữ liệu nhập khẩu phần mềm kế toán'
	},

	InvoiceInbot: {
		InvoiceLoadingTab: 'Hóa đơn đang tải',
		InputInvoiceTab: 'Hóa đơn đầu vào',
		LoadingStatus: 'Trạng thái',
		LoadingDescription: 'Mô tả chi tiết',
		SellerTaxCode: 'MST người bán',
		SellerName: 'Tên người bán',
		InvoiceDateRange: 'Ngày hóa đơn',
		InvoiceLoadingBanner: 'Danh sách hóa đơn đang hoàn tất quá trình tải dữ liệu từ CQT.',
		//===============
		Selected: 'Đã chọn ',
		Invoice: 'hóa đơn',
		PrintInvoice: 'In hóa đơn',
		RemoveStick: 'Gỡ nhãn',
		CheckAgain: 'Kiểm tra lại',
		DownloadPdfAndXml: 'Bản thể hiện và XML',
		DownloadAll: 'Tất cả (Tệp đính kèm, Bản thể hiện, XML)',
		MoveInvoice: 'Điều chuyển hóa đơn',
		MoveInvoiceSelectOrgTitle: 'Chọn đơn vị muốn điều chuyển',
		MoveInvoiceSelectOrgMessage: 'Bạn cần chọn đơn vị muốn điều chuyển tờ khai trước khi nhấn "Đồng ý".',
		NoSearchResultOrg: 'Không tìm thấy thông tin đơn vị theo điều kiện tìm kiếm, vui lòng thử lại',
		Period: 'Kỳ',
		KindAccountingDate: 'Tình trạng hạch toán',
		Status: 'Trạng thái',
		Stick: 'Nhãn dán',
		ReceiveInvoice: 'Nguồn hóa đơn',
		StatusInvoice: 'Trạng thái hóa đơn',
		RemoveFilter: 'Bỏ lọc',
		Hide: 'Ẩn',
		Close: 'Đóng',
		Download: 'Tải xuống',
		Delete: 'Xóa',
		Edit: 'Sửa',
		Agree: 'Đồng ý',
		//===============
		All: 'Tất cả',
		Accounted: 'Đã hạch toán',
		UnAccounting: 'Chưa hạch toán',

		//===============
		InvoiceOriginal: 'HĐ mới',
		InvoiceReplace: 'HĐ thay thế',
		InvoiceAdjust: 'HĐ điều chỉnh',
		InvoiceReplaced: 'HĐ đã bị thay thế',
		InvoiceAdjusted: 'HĐ đã bị điều chỉnh',
		InvoiceCancel: 'HĐ đã bị hủy',
		InvoiceUnknow: 'HĐ chưa xác định',
		BeforeVatAmount: 'Tổng tiền trước thuế',
		VatAmount: 'Tổng tiền thuế',
		TotalVATAmountCC: 'Tổng tiền thuế quy đổi',
		TotalAmount: 'Tổng tiền',
		BeforeVatAmountTooltip: 'Tổng tiền trước thuế quy đổi',
		VatAmountTooltip: 'Tổng tiền thuế quy đổi',
		TotalAmountTooltip: 'Tổng giá trị quy đổi',

		//===============
		UpdateSuccess: 'Cập nhật thành công',
		DeleteSuccess: 'Đã xóa thành công',
		DeleteInvoice: 'Xóa hóa đơn',
		DeleteInvoiceSuccess: 'Đã xóa hóa đơn thành công',
		ViewDetail: 'Xem chi tiết',
		ViewDetailInvoice: 'Xem chi tiết hóa đơn',
		Receipt: 'biên lai',
		ConfirmDeleteInvoice: `Dữ liệu sau khi xóa vẫn có thể thể khôi phục lại tại mục “Hóa đơn đã xóa”.`,
		InvoiceCreateVoucher: 'Hóa đơn này đã được lập chứng từ số',
		ConfirmInvoicesSeleted: 'Bạn có chắc chắn muốn xóa các hóa đơn đã chọn không?',
		ConfirmInvoiceSeleted: 'Bạn có chắc chắn muốn xóa hóa đơn đã chọn không?',
		ConfirmDeletePdf: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.',
		InvoiceListSelected: 'Danh sách hóa đơn đã chọn này đã được lập chứng từ số',
		SystemChecking: 'Hệ thống đang kiểm tra và sẽ trả về kết quả sau ít phút.',
		SystemMoving: 'Hệ thống đang điều chuyển hóa đơn và sẽ trả về kết quả sau ít phút.',
		NoteSystemChecking:
			'Chỉ cập nhật được trạng thái với các hóa đơn/vé có tồn tại trên hệ thống của Cơ quan thuế.',
		AppCheckingLimit: 'Chương trình chỉ cho phép kiểm tra tối đa',
		CopyEmailSuccess: 'Sao chép email thành công',

		//========
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		Company: 'Công ty',
		Branch: 'Chi nhánh',
		Department: 'Phòng ban',
		RestoreInvoiceSuccess: 'Khôi phục hóa đơn thành công',
		InvoiceType: 'Loại hóa đơn',
		InvoiceSelected: number => `${number} hóa đơn`,
		Selected: 'Đã chọn',
		UnSelected: 'Bỏ chọn',
		CheckTax: 'Kiểm tra thuế',
		AcceptTax: 'Chấp nhận',
		InvoiceListSelected: 'Danh sách hóa đơn đã chọn',
		OverLine: 'Vượt quá số lượng dòng',
		InvoiceSelectedWarning: number => `Bạn chỉ được chọn tối đa ${number} hóa đơn.`,
		ListRiskInvoiceBySupplier: 'Danh sách hóa đơn rủi ro theo nhà cung cấp',
		Viewed: 'Đã xem',
		UnViewed: 'Chưa xem',
		LookInfo: 'Tra cứu thông tin',
		NonSupportCheckAgain:
			'Chương trình chỉ thực hiện Kiểm tra lại với các hóa đơn khác hóa đơn của nhà cung cấp Google, Meta, Zoom, Tiktok, Microsoft, Celonis, Paddle, Tokgistic.',
		ClassificationCost: 'Phân loại chi phí',
		SelectCostType: 'Chọn chi phí',
		ClassificationCostSuccess: 'Phân loại thành công',
		ClassificationCostFail: 'Phân loại không thành công',
		UpdateInvoiceDetail: 'Cập nhật chi tiết hóa đơn',
		UpdateInvoiceDetailWarning1: `Chương trình chỉ thực hiện <span style="font-weight: 700; font-size: 13px; line-height: 20px; letter-spacing: 0; font-variant-numeric: lining-nums tabular-nums;">Cập nhật chi tiết hóa đơn</span> với các hóa đơn không có hàng hóa, dịch vụ chi tiết.`,
		TitleInvDetailExists: 'Tồn tại hóa đơn có hàng hóa, dịch vụ chi tiết',
		SystemUpdateInvoiceDetail: 'Hệ thống đang tiến hành cập nhật dữ liệu và sẽ trả về kết quả sau ít phút.'
	},

	Export: {
		MessageNotifiExport: 'Dữ liệu xuất khẩu sẽ được lấy theo điều kiện lọc trên danh sách hóa đơn',
		MessageNotifiExportLimit: number =>
			`Dữ liệu xuất khẩu được lấy theo điều kiện lọc trên danh sách, tối đa <b class='font-bold'>${number}</b> hóa đơn.`,
		NumberLimitExport: number => `Xuất tối đa ${number} bản ghi trên 1 lần`
	},

	Stick: {
		StickNewName: 'Nhập tên cho nhãn mới',
		StickName: 'Tên nhãn',
		Color: 'Màu sắc',
		AutoStickByTaxCode: 'Tự động gắn nhãn theo Mã số thuế/CCCD của NCC',
		StickNameSearch: 'Nhập tên nhãn dãn để tìm',
		Delete: 'Xóa',
		Edit: 'Sửa',
		NotResult: 'Không tìm thấy thông tin nhãn dán theo điều kiện tìm kiếm, vui lòng thử lại',
		AddStick: 'Thêm nhãn',
		Cancel: 'Hủy bỏ',
		Stick: 'Nhãn dán',
		UpdateChangeStick: 'Cập nhật thay đổi nhãn',
		ConfirmDeleteStick: 'Nhãn sẽ bị xóa tại tất cả các Hóa đơn đã gắn nhãn. Bạn có chắc chắn muốn tiếp tục?',
		DeleteStick: 'Xóa nhãn dán',
		ConfirmDeleteStick1: 'Nhãn sẽ bị xóa tại tất cả các Hóa đơn đã gắn nhãn. Bạn có chắc chắn muốn xóa?',
		DeleteStickSuccess: 'Xóa nhãn dán thành công',
		NoStick: 'Không có nhãn dán nào',
		NotStick: 'Không có nhãn dán',
		StickNote:
			'Tính năng gắn nhãn phù hợp với các nhãn được người dùng sử dụng nhiều lần. Nếu nhãn chỉ dùng một vài lần, hãy chuyển sang sử dụng Ghi chú.',
		NoteInsertWarning: numberRecord =>
			`Bạn không thể thêm nhãn mới vì số lượng nhãn hiện tại đã đạt tối đa là <b class='font-bold'>${numberRecord}</b>. Vui lòng xóa bớt nhãn trước khi thêm mới.`
	},

	InvoiceDetail: {
		AddressCheckSetting: 'Thiết lập kiểm tra địa chỉ',
		TitleBtnUpdateInvoiceDetail: 'Cập nhật chi tiết hóa đơn',
		TitleBtnUpdateInvoiceDetailProcess: 'Đang cập nhật chi tiết hóa đơn',
		TitleInvNoDetail: 'Hóa đơn không có dòng chi tiết',
		MessageInvNoDetail:
			'<div style="line-height: 20px">Hóa đơn được lấy từ Bảng tổng hợp trên Cơ quan thuế và không chứa thông tin về chi tiết hàng hóa, dịch vụ.<br/> Để kết quả kiểm tra hóa đơn được chính xác, vui lòng <span style="font-weight: 700; font-size: 13px; line-height: 20px; letter-spacing: 0; font-variant-numeric: lining-nums tabular-nums;">tải lên</span> file xml của hóa đơn.</div>',
		MessageInvNoDetails:
			'<div style="line-height: 20px">Các hóa đơn được lấy từ Bảng tổng hợp trên Cơ quan thuế và không chứa thông tin về chi tiết hàng hóa, dịch vụ.<br/> Để kiểm tra hóa đơn được chính xác, vui lòng <span style="font-weight: 700; font-size: 13px; line-height: 20px; letter-spacing: 0; font-variant-numeric: lining-nums tabular-nums;">tải lên</span> file xml của từng hóa đơn.</div>',
		BussinessList: 'Danh sách ngành nghề kinh doanh',
		SerialNumber: 'STT',
		MajorCode: 'Mã ngành',
		MajorName: 'Tên ngành',
		NNKD: 'NNKD Chính',
		ImageCheckTaxaxion: 'Ảnh chụp kết quả tra cứu trên website của Cơ quan Thuế',
		NoImageSearch: 'Không lấy được hình ảnh tra cứu',
		NotFileAttach: 'Chưa có tệp đính kèm nào',
		ConfirmDeleteFile: 'Bạn chắc chắn muốn xóa tệp đính kèm này không?',
		DeleteFileAttach: 'Xóa tệp đính kèm',
		DeleteFileSuccess: 'Xóa tệp đính kèm thành công',
		UploadFileSuccess: 'Tải tệp đính kèm thành công',
		DeletePdfTooltip: 'Xóa bản thể hiện',
		DeletePdf: 'Bạn muốn xóa bản thể hiện',
		UploadPdf: 'Tải bản thể hiện',
		UploadPdfAnother: 'Tải lên bản thể hiện khác',
		DeletePdfSuccess: 'Đã xóa bản thể hiện thành công.',
		DeletePdfFail: 'Xóa bản thể hiện thất bại.',
		HelpShortenTemplateTooltip: 'Hướng dẫn thiết lập hiển thị thông tin trên mẫu hóa đơn',
		IntroduceTemplate: isReceipt =>
			`Đây là bản thể hiện của ${
				!isReceipt ? 'hóa đơn' : 'biên lai'
			} dựa trên nội dung file pdf/ảnh. Bạn có thể tải lên file pdf/ảnh mới`,
		Here: 'Tại đây',
		IntroduceResult: isReceipt =>
			`Thông tin và kết quả kiểm tra theo file XML của ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		NoInfomation: 'Không có thông tin',
		Checking: 'Đang kiểm tra',
		VatExact: 'Thuế suất chính xác',
		VatNotExact: 'Thuế suất chưa chính xác',
		ItemReductionAndNotReduction: 'Bao gồm mặt hàng giảm thuế và không giảm thuế',
		CheckVatRateInvoice: 'Kiểm tra thuế suất hóa đơn',
		NoSearchResultInvoice: 'Không tìm thấy thông tin hóa đơn theo điều kiện tìm kiếm, vui lòng thử lại',
		IntroduceInfoND123:
			'từ ngày 25/01/2022. MISA Meinvoice - Xử lý hóa đơn đầu vào bổ sung tính năng kiểm tra tính hợp lệ hóa đơn theo nghị định mới tại Nghị định 123/2020/NĐ-CP và kiểm tra tính chính xác về tính toán số liệu đối với các hóa đơn theo Nghị định 123/2020/NĐ-CP. Vui lòng nhấn',
		checkAgain: 'kiểm tra lại',
		ResultNew: 'để có kết quả mới nhất',
		PrintCheckingResult: 'In kết quả kiểm tra',
		DownloadAgain: 'Tải lại',
		Cancel: 'Hủy bỏ',
		Confirm: 'Xác nhận',

		//==============
		WaterServiceAmount: 'Tiền dịch vụ thoát nước',
		WaterServiceVatAmount: 'Thuế dịch vụ thoát nước',
		FeeEnvironment: 'Phí bảo vệ môi trường',
		InvoiceDateDelete: 'Ngày xóa bỏ',
		ReasonDelete: 'Lý do xóa bỏ',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		ReceiptNo: 'Số biên lai',
		InvoiceNoText: 'Số hóa đơn',
		ReceiptDate: 'Ngày biên lai',
		InvoiceDateText: 'Ngày hóa đơn',
		Noted: 'Ghi chú',
		PaymentMethod: 'Thông tin thanh toán',
		Reason: 'Lý do',
		InvoiceProcessStatus: 'Trạng thái xử lý hóa đơn',
		NoteText: 'Lưu ý',
		InvoiceNoCode: 'Hóa đơn không mã có thể được gửi theo hình thức',
		TableSummaryDeclarate: 'Bảng tổng hợp dữ liệu định kỳ theo kỳ kê khai lên CQT',
		HaveYet: 'Chưa có',
		InvoiceReplaced: 'Hóa đơn đã bị thay thế',
		InvoiceAdjusted: 'Hóa đơn bị điều chỉnh',
		InvoiceCancel: 'Hóa đơn đã bị xóa bỏ/hủy bỏ',
		InvoiceNew: 'Hóa đơn mới',
		InvoiceNewCKTM: 'Hóa đơn mới (CKTM)',
		BuyerDeclarate: 'Tên người mua đã khai báo',
		BuyerNameTaxaxion: 'Tên người mua kiểm tra trên website của Cơ quan thuế',
		BuyerAddressTaxaxion: 'Địa chỉ người mua kiểm tra trên website của Cơ quan thuế',
		AcceptBuyerName: 'Chấp nhận tên người mua này',
		AcceptBuyerTaxCode: 'Chấp nhận MST người mua này',
		UnacceptBuyerName: 'Bỏ chấp nhận tên người mua',
		UnacceptBuyerTaxCode: 'Bỏ chấp nhận MST người mua',
		TaxCodeDeclarate: 'Mã số thuế đã khai báo',
		TaxCodeDeclarateHKD: 'Mã số thuế/CCCD chủ hộ đã khai báo',
		AddressDeclarate: 'Địa chỉ đã khai báo',
		IdentificationDeclarate: 'Căn cước công dân đã khai báo',
		NotDataDeclarate: 'Chưa có thông tin khai báo đầu vào để kiểm tra hóa đơn.',
		AcceptAddress: 'Chấp nhận địa chỉ này',
		SellerAcceptAddress: 'Chấp nhận địa chỉ người bán này',
		BuyerAcceptAddress: 'Chấp nhận địa chỉ người mua này',
		SellerNameTaxaxion: 'Tên người bán kiểm tra trên website của Cơ quan thuế',
		AcceptSellerName: 'Chấp nhận tên người bán này',
		AcceptSignature: 'Chấp nhận chữ ký số này',
		AcceptActiveSeller: 'Chấp nhận hoạt động người bán',
		AcceptValid: 'Chấp nhận hợp lệ',
		SetupFormula: 'Thiết lập công thức tính toán số liệu',
		SetupFormulaConfirmMessage: `<span style='color: #10141B'>Việc thay đổi thiết lập có thể làm ảnh hưởng đến kết quả kiểm tra hóa đơn.<br><div style='margin-top: 8px'>Vui lòng nhấn <span style="font-weight: 700">Đồng ý</span> để kiểm tra và cập lại hóa đơn hiện tại, đối với hóa đơn cũ vui lòng nhấn <span style="font-weight: 700">Kiểm tra lại</span> để cập nhật kết quả kiểm tra mới nhất.</div></span>`,
		SetupFormulaConfirmMessage1: `<span style='color: #10141B'>Việc thay đổi thiết lập có thể làm ảnh hưởng đến kết quả kiểm tra hóa đơn.<br>Vui lòng nhấn <span style="font-weight: 700">Kiểm tra lại</span> trên các hóa đơn để cập nhật kết quả kiểm tra mới nhất.</span>`,
		TitleSetupFormula: 'Bạn muốn thay đổi thiết lập',
		AcceptInvoiceName: 'Chấp nhận tên hóa đơn này',
		UnacceptInvoiceName: 'Bỏ chấp nhận tên hóa đơn',
		AcceptedInvoiceNameEmpty: 'Đã chấp nhận thiếu tên hóa đơn',
		AcceptRiskTax: 'Chấp nhận rủi ro về thuế',
		BackDateRealease: 'Ngày quay lại thông báo phát hành',
		CompareDataTaxaxion: 'Đối chiếu với dữ liệu CQT ngày',
		InvoiceNoCode:
			'Đây là HĐ không mã gửi đến CQT theo Bảng tổng hợp. Một số thông tin không bắt buộc có trên bảng tổng hợp. Vui lòng upload file XML của hóa đơn để kết quả kiểm tra được đầy đủ.',
		//============
		StatusValid: isInvoice => `${isInvoice ? 'Hóa đơn' : 'Biên lai'} hợp lệ`,
		StatusInValid: isInvoice => `${isInvoice ? 'Hóa đơn' : 'Biên lai'} không hợp lệ`,
		InvoiceNo: isInvoice => `Số ${isInvoice ? 'hóa đơn' : 'biên lai'}`,
		InvoiceDate: isInvoice => `Ngày ${isInvoice ? 'hóa đơn' : 'biên lai'}`,
		InvoiceDelete: isInvoice => `${isInvoice ? 'Hóa đơn' : 'Biên lai'} xóa bỏ`,
		InvoiceHanding: isInvoice => `${isInvoice ? 'Hóa đơn' : 'Biên lai'} nhập tay`,
		InvoiceTThaiHDonEnum: (status, TThaiHDonEnum) =>
			`Hóa đơn ${status == TThaiHDonEnum ? 'thay thế' : 'điều chỉnh'}`,
		ReceiptTThaiHDonEnum: (status, TThaiHDonEnum) =>
			`Biên lai ${status == TThaiHDonEnum ? 'thay thế' : 'điều chỉnh'}`,
		BuyerName: isReceipt => `Tên người mua trên ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		TaxCodeInvoice: isReceipt => `Mã số thuế trên ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		AddressInvoice: isReceipt => `Địa chỉ trên ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		IdentificationNumberInvoice: isReceipt => `Căn cước công dân trên ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		SellerNameInvoice: isReceipt => `Tên người bán trên ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		SignatureSellerFail: isReceipt =>
			`Chữ ký số bên bán bị lỗi dẫn đến không kiểm tra được chữ ký số trên ${
				!isReceipt ? 'hóa đơn' : 'biên lai'
			}`,
		SignatureTaxaxionFail: isReceipt =>
			`Chữ ký số Cơ quan thuế bị lỗi dẫn đến không kiểm tra được chữ ký số trên ${
				!isReceipt ? 'hóa đơn' : 'biên lai'
			}`,
		PaymentMethodInvoice: textAmount => `Hình thức thanh toán tiền mặt với giá trị ≥ ${textAmount} triệu đồng`,
		PaymentValid: 'Hình thức thanh toán hợp lệ',
		PaymentValidTooltip:
			'Không vi phạm trường hợp hóa đơn ≥ 5 triệu đồng được thanh toán bằng tiền mặt. Để đảm bảo việc khấu trừ thuế đầu vào và ghi nhận chi phí hợp lệ diễn ra thuận lợi, đừng quên rà soát lại hình thức thanh toán của các hóa đơn khác nếu cùng ngày, tổng hóa đơn của 1 nhà cung cấp đạt từ 5 triệu đồng hoặc 20 triệu đồng trở lên',
		StopDatePrint: isReceipt =>
			`${!isReceipt ? 'Ngày ngừng sử dụng HĐ tự in: ' : 'Ngày ngừng sử dụng biên lai tự in: '}`,

		//Mới thêm
		NumberInvoicePaymentExpired: number => `Bạn có ${number} Hóa đơn đến hạn thanh toán`,
		WarningNumberInvoiceExist: length =>
			`Có ${length} hóa đơn đã tồn tại ghi chú. Vui lòng chọn hóa đơn bạn muốn thay thế ghi chú`,
		InvoiceEnoughConditionCode: 'Hóa đơn không đủ điều kiện cấp mã',
		BeyondTheNormInvoiceCheckValid: 'Vượt định mức chi phí',
		BeyondTheNormInvoiceCheckInvalid: 'Nằm trong định mức chi phí',
		TotalAmountExchange: 'Thành tiền quy đổi',
		AllowedLevel: 'Định mức cho phép',
		UpdateCostType: 'Cập nhật định mức',
		InvoiceEnough: 'Hóa đơn đủ điều kiện cấp mã',
		SupplyInvoiceCode: 'Đã cấp mã Hóa đơn',
		TaxaxionReceiveWithoutCode: 'Cơ quan Thuế đã nhận không mã',
		CheckedInvoiceWithoutCode: 'Đã kiểm tra định kỳ HĐĐT không có mã',
		NhanHDMayTinhTien: 'Đã tiếp nhận hóa đơn máy tính tiền',
		TaxaxionReceived: 'Cơ quan Thuế đã nhận',
		ProcessingCheckSupplyCode: 'Đang tiến hành kiểm tra điều kiện cấp mã',
		TaxaxionRefuseInvoice: 'CQT từ chối hóa đơn theo từng lần phát sinh',
		InputContentNote: 'Nhập nội dung ghi chú tại đây',
		InvoiceReplaceFull: 'Hóa đơn thay thế',
		InvoiceReplacedFull: 'Hóa đơn bị thay thế',
		InvoiceAdjustFull: 'Hóa đơn điều chỉnh',
		InvoiceAdjustedFull: 'Hóa đơn bị điều chỉnh',
		InvoiceCancelFull: 'Hóa đơn đã bị hủy',
		Unknow: 'Chưa xác định',
		InvoiceValidAfterCheck: 'Hóa đơn hợp lệ với các trường thông tin đã kiểm tra',
		SignatureDateUnknow: 'Không có thông tin ngày ký Hóa đơn',
		CertificateNoUnknow: 'Không có MST người bán trong thông tin CTS',
		CertificateNoStatusUnknow: 'Không xác định được trạng thái hợp lệ của CTS',
		TaxRiskBuyerStatus: 'Người bán rủi ro tại thời điểm phát hành Hóa đơn',
		InvoiceNotExistTaxaxion: 'Hóa đơn không tồn tại trên hệ thống Cơ quan thuế tại thời điểm kiểm tra',
		InvoiceCheckingTaxaxion: 'Đang kiểm tra trạng thái hóa đơn trên hệ thống của TCT',
		TitleConfirmCheckTax: 'Chấp nhận thuế suất',
		ContentConfirmCheckTax: 'Bạn có chắc nhận muốn chấp nhận thuế suất này?',
		ViewInvoiceDetailRef: 'Xem chi tiết thông tin liên quan',
		SelectedInvoices: number => `Đã chọn ${number} hóa đơn`,
		MarkAccountingDate: 'Đánh dấu hạch toán',
		ViewTBSS: 'Xem thông báo sai sót',
		InvoiceNotPdfSupplier:
			'Chưa có bản thể hiện hóa đơn của người bán trên hệ thống, vui lòng nhấn tải lên hóa đơn',
		Instance: 'Mẫu người bán',
		DefaultTemplate: 'Mẫu mặc định',
		SearchSuggestions: 'Gợi ý tra cứu',
		LinkSearch: 'Link tra cứu',
		CodeSearch: 'Mã tra cứu',
		LinkDownloadPDF: 'Link tải hóa đơn PDF',
		ClickHere: 'Click vào đây',
		HelpXml: isReceipt => `Đây là mẫu dựa trên nội dung XML của ${isReceipt ? 'biên lai' : 'hóa đơn'}`,
		HelpPdf: 'Đây là mẫu dựa trên nội dung đọc từ PDF của hóa đơn',
		InputLinkSearch: 'Nhập link tra cứu',
		InputCodeSearch: 'Nhập mã tra cứu',
		OrSearchInvoiceFromSupplier: 'Hoặc tra cứu hóa đơn trực tiếp từ nhà cung cấp',
		WarningWithoutCodeInvoice:
			'HĐ không mã gửi đến CQT theo Bảng tổng hợp. Bạn nên tải XML của HĐ để kết quả kiểm tra được đầy đủ.',
		NotFindRelaticeInvoice: statusInvoice =>
			`${statusInvoice} liên quan chưa có trên hệ thống MISA meInvoice - Xử lý hóa đơn. Vui lòng đưa hóa đơn liên quan vào chương trình bằng một trong các cách sau:`,
		UploadInvoice: 'Tải lên hóa đơn',
		SendEmailInvoice: 'Gửi email hóa đơn',
		DownloadInvoiceFromTax: 'Tải hóa đơn từ Cơ quan Thuế',
		DownloadInvoiceFromSupplier: 'Tải hóa đơn từ nhà cung cấp',
		StopUsingTaxaxion: 'Kiểm tra HĐ có bị ngừng sử dụng không'
	},

	InvoiceHand: {
		INVOICEINPUT: 'Nhập liệu hóa đơn',
		FailFomatVatRate: 'Sai định dạng thuế suất',
		FormatNumberVatRate: 'Thuế suất chỉ cho phép 2 số phần thập phân',
		SaveDraft: 'Lưu nháp',
		UnitName: 'Đơn vị tính',
		ConfirmUpdatePdf:
			'Đã tồn tại XML hóa đơn có thông tin đã nhập. Bạn có muốn cập nhật bản thể hiện cho hóa đơn này.',
		TitleConfirmPdf: 'Cập nhật bản thể hiện',
		TaxCodeOrIdentifiValid: 'Mã số thuế/Căn cước công dân chủ HKD'
	},

	InvoiceTrial: {
		CheckingResult: 'Kết quả kiểm tra hóa đơn',
		InvoiceInValid: 'Hóa đơn không hợp lệ',
		InvoiceDelete: 'Hóa đơn xóa bỏ',
		TaxCodeOnInvoice: 'Mã số thuế trên hóa đơn',
		BuyerNameOnInvoice: 'Tên người mua trên hóa đơn',
		SellerNameOnInvoice: 'Tên người bán trên hóa đơn',
		SignatureSellerFailNotChecking: 'Chữ ký số bên bán bị lỗi dẫn đến không kiểm tra được chữ ký số trên hóa đơn',
		PaymentMethod: 'Phương thức thanh toán',
		CreateRef: 'Lập chứng từ',
		SyncAppAccounting: 'Đồng bộ phần mềm kế toán',
		SyncAccountingAIMarketing: {
			Title: 'Hết số lượt dùng thử tính năng kiểm tra hóa đơn hợp lệ',
			ContentTop: link =>
				`Để tiếp tục sử dụng đầy đủ các tính năng trên, vui lòng đăng nhập phần mềm <a href='${link}' target='_blank' style='color: #00aab7; text-decoration: revert;'>Xử lý hóa đơn MISA meInvoice</a> (nếu bạn đã có Tài khoản phần mềm) hoặc nhấn <span style='color: #F3674C;'>"ĐĂNG KÝ NHẬN TƯ VẤN MIỄN PHÍ"</span> để được hỗ trợ và DEMO 1 -1 miễn phí.`,
			BoxTitle: 'Giải pháp Xử lý hóa đơn MISA meInvoice - Rút ngắn 80% thời gian quản lý hóa đơn',
			BoxContent1: 'Đồng bộ với phần mềm kế toán để tự động nhập liệu và hạch toán',
			BoxContent2: 'Tải file hóa đơn PDF gốc của NCC (có logo, link và mã tra cứu)',
			BoxContent3: 'Tự động tra cứu, phát hiện sai sót và cảnh báo rủi ro trên hóa đơn',
			BoxContent4: 'Tự động tải hoá đơn từ nhà cung cấp',
			Button: 'ĐĂNG KÝ NHẬN TƯ VẤN MIỄN PHÍ'
		}
	},

	CheckVat: {
		TotalRecords: 'Tổng số bản ghi',
		ItemName: 'Tên hàng hóa, dịch vụ/ Mã số HS',
		VatRate: 'Thuế suất',
		DiscountVatRate: 'Giảm thuế',
		CheckVatRate: 'Kiểm tra thuế suất',
		HaveReduction: 'Có giảm thuế',
		NotReduction: 'Không giảm thuế',
		CheckNow: 'Kiểm tra ngay',
		Correct: 'Chính xác',
		InCorrect: 'Không chính xác',
		YetCheck: 'Chưa kiểm tra'
	},

	CheckItems: {
		Title: 'Ngành nghề kinh doanh',
		TextValid: 'Chưa phát hiện hàng hóa, dịch vụ không phù hợp với ngành nghề kinh doanh của người bán',
		TextInValid: number =>
			`Phát hiện ${number} hàng hóa, dịch vụ chưa phù hợp với ngành nghề kinh doanh của người bán`,
		SearchPlaceHolder: 'Nhập tên hàng hóa dịch vụ để tìm kiếm',
		AVAComment:
			'Kết quả kiểm tra dựa trên công nghệ AI và mang tính chất tham khảo. Quý khách có thể hỗ trợ gia tăng độ chính xác cho MISA AVA bằng cách đánh giá kết quả gợi ý.',
		ViewBusiness: 'Xem ngành nghề kinh doanh người bán',
		BusinessColumn: 'Ngành nghề kinh doanh phù hợp',
		RateAva: 'Đánh giá kết quả gợi ý của AVA',
		Right: 'Đúng',
		Wrong: 'Sai',
		NotFound: 'Không tìm thấy',
		AcceptRight: 'Được chấp nhận phù hợp'
	},

	Template: {
		SellerStoreNumber: 'Cửa hàng số',
		Day: 'Ngày',
		month: 'tháng',
		year: 'năm',
		UploadPdf: 'Chọn tệp để tải lên',
		PaymentMethod: 'Hình thức thanh toán',
		OrderNo: 'Đơn đặt hàng số',
		OrderReason: 'Số tham khảo',
		CcyCode: 'Đơn vị tiền tệ',
		Warehouse: 'Kho',
		PickslipNo: 'Phiếu nhận hàng số',
		ItemCode: 'Mã hàng hóa',
		ItemCode1: 'Mã hàng',
		WaterSX: 'Nước SX',
		BatchNo: 'Số lô',
		ExpiredDate: 'Hạn sử dụng',
		ExpiredDate1: 'Hạn sử dụng',
		UnitName: 'Đơn vị tính',
		Quantity: 'Số lượng',
		UnitPrice: 'Đơn giá',
		TotalAmount: 'Thành tiền',
		VatRate: 'Thuế suất GTGT',
		VatRate1: 'Thuế suất',
		VatAmount: 'Tiền thuế GTGT',
		SumTotalAmount: 'Cộng tiền hàng',
		SumTotalFee: 'Cộng tiền phí',
		DiscountRate: 'Tỷ lệ chiết khấu',
		Vat: 'Thuế',
		DiscountAmount: 'Số tiền chiết khấu',
		FeeServiceRate: 'Tỷ lệ phí dịch vụ',
		FeeServiceAmount: 'Phí dịch vụ',
		VatTTDBRate: 'Thuế suất thuế TTĐB',
		VatTTDBAmount: 'Tiền thuế TTĐB',
		FeeEnvironmentRate: 'Phí môi trường',
		FeeEnvironmentAmount: 'Tiền phí môi trường',
		VatRateTicket: 'Thuế suất GTGT trên giá vé',
		CollectionsAmount: 'Các khoản thu hộ khác',
		FeeOther: 'Phí khác',
		TotalAmountTicket: 'Tổng tiền vé',
		FeeServiceSellTicket: 'Phần thu dịch vụ bán vé',
		FeeServiceTotalSellTicket: 'Tiền phí dịch vụ bán vé',
		TotalAmountFeeService: 'Tổng tiền phí dịch vụ',
		TotalAmountPayment: 'Tổng tiền thanh toán',
		TotalAmountText: 'Số tiền viết bằng chữ',
		BuyerFullName: 'Người mua hàng',
		SignatureFullName: 'Ký ghi rõ họ tên',
		DigitalSignature: 'Chữ ký số (nếu có)',
		DigitalSignature1: '(Chữ ký số nếu có)',
		ElectronicDigitalSignature: 'Chữ ký điện tử, chữ ký số',
		ElectronicDigitalSignature1: '(Chữ ký điện tử, chữ ký số)',
		SingnatureBy: 'Ký bởi',
		SignatureDate: 'Ngày ký',
		PleaseUploadFile: 'Vui lòng tải file pdf/ảnh',
		SellerName: 'Tên người bán',
		BuyerName: 'Tên người mua',
		FullNameBuyerItem: 'Họ và tên người mua hàng',
		FullNameBuyerItem1: 'Họ tên người mua hàng',
		AccoutNumber: 'Số tài khoản',
		Phone: 'Điện thoại',
		PaymentCurrentcy: 'Đồng tiền thanh toán',
		DeclarationNumber: 'Số bảng kê',
		DeclarationDate: 'Ngày bảng kê',
		CitizenIdentityCardId: 'Căn cước công dân',
		CitizenIdentityCardId1: 'CCCD người mua',
		PassportNumber: 'Số hộ chiếu',
		MSDVCQHVNS: 'MSĐVCQHVNS',
		MSDVCQHVNSNN: 'Mã ĐVCQHVNSNN',
		SeriesNo: 'STT',
		Nature: 'Tính chất',
		ItemName: 'Tên hàng hóa dịch vụ',
		ItemName1: 'Tên hàng hóa, dịch vụ',
		TotalAmountWithoutVat: 'Thành tiền chưa trừ chiết khấu',
		DiscountAmount123: 'Tiền chiết khấu',
		DiscountAmount1231: 'Chiết khấu',
		TotalAmountBeforeVat: 'Thành tiền trước thuế GTGT',
		SumTotalAmoutPayment: 'Cộng tiền thanh toán',
		ExhangeRate: 'Tỷ giá',
		TotalExhange: 'Quy đổi',

		VatAmount10: 'Tổng tiền chịu thuế suất 10%',
		VatAmount8: 'Tổng tiền chịu thuế suất 8%',
		VatAmount5: 'Tổng tiền chịu thuế suất 5%',
		VatAmount0: 'Tổng tiền chịu thuế suất 0%',
		VatAmountText: vat => `Thuế suất ${vat}%`,
		VatAmountKCT: 'Tổng tiền không chịu thuế GTGT',
		VatAmountKCT1: 'Không chịu thuế GTGT',
		VatAmountKKKNT: 'Tổng tiền không kê khai nộp thuế',
		VatAmountKKKNT1: 'Không kê khai nộp thuế GTGT',
		VatAmountOther: 'Tổng tiền chịu thuế suất khác',
		VatAmountOther1: 'Thuế suất khác',
		VatAmountFinancialLease: 'Thuế suất cho thuê tài chính',
		VatAmountKTPVDC: 'Không thuộc phạm vi điều chỉnh của Luật thuế',
		VatAmountKTGTT: 'Không tính vào giá tính thuế GTGT',
		TotalAmountWithoutVat123: 'Tổng tiền chưa thuế',
		RemoveDiscountAmount: 'Đã trừ chiết khấu',
		TotalVATAmount: 'Tổng tiền thuế',
		TotalVATAmountCC: 'Tổng tiền thuế quy đổi',
		TotalAmountFee: 'Tổng tiền phí',
		TotalDiscountAmount2: 'Tổng tiền chiết khấu thương mại',
		TotalAmountFullNumber: 'Tổng tiền thanh toán bằng số',
		TotalAmountFullText: 'Tổng tiền thanh toán bằng chữ',
		SumTotalAmountVat: 'Tổng cộng tiền thuế',
		SellerInfoF: isReceipt => `${!isReceipt ? 'Người bán hàng' : 'Người thu tiền'}`,
		ItemNameF: isReceipt => `${!isReceipt ? 'Tên hàng hóa dịch vụ' : 'Tên loại phí, lệ phí'}`,
		PreviewInvoice: isReceipt =>
			`${!isReceipt ? '(Bản thể hiện của hóa đơn điện tử)' : '(Bản thể hiện của biên lai điện tử)'}`,
		InvoiceNoF: isReceipt => `${!isReceipt ? 'Số hóa đơn' : 'Số biên lai'}`,
		PreviewInvoiceXML: isReceipt =>
			`Đây là bản thể hiện dựa trên nội dung XML của ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		PreviewInvoiceXML1: isReceipt =>
			`Nội dung này có thể không chính xác theo đúng biểu mẫu của ${!isReceipt ? 'hóa đơn' : 'biên lai'}`,
		TaxReductionAmount30: (totalTaxReductionAmount, ccyCode) =>
			`Đã giảm ${totalTaxReductionAmount} ${ccyCode}, tương ứng 30% mức tỷ lệ để tính thuế giá trị gia tăng theo Nghị quyết số 406/NQ-UBTVQH15`,
		TaxReductionAmount43: (totalTaxReductionAmount43, ccyCode) =>
			`Đã giảm ${totalTaxReductionAmount43} ${ccyCode}, tương ứng 20% mức tỷ lệ % để tính thuế giá trị gia tăng theo Nghị quyết số 43/2022/QH15`,
		TaxReductionAmount101: (total, ccyCode) =>
			`Đã giảm ${total} ${ccyCode} tương ứng 20% mức tỷ lệ % để tính thuế giá trị gia tăng theo Nghị quyết số 101/2023/QH15`,
		TaxReductionAmount43Or101: (total, ccyCode) =>
			`Đã giảm ${total} ${ccyCode} tương ứng 20% mức tỷ lệ % để tính thuế giá trị gia tăng theo Nghị quyết số 43/2022/QH15 hoặc Nghị quyết số 101/2023/QH15`,
		//Bổ sung 1/5/2023
		Seller: 'Người xuất hàng',
		SellerNameExport: 'Tên người xuất hàng',
		Decree: 'Căn cứ hợp đồng kinh tế số',
		ShipperName: 'Tên người vận chuyển',
		NumberAgreement: 'Hợp đồng số',
		VehicleType: 'Phương tiện vận chuyển',
		Recipient: 'Người nhận hàng',
		RecipientName: 'Tên người nhận hàng',
		RecipientFullName: 'Họ và tên người nhận hàng',
		PleaseUploadFile: 'Vui lòng tải lên file pdf/ảnh',

		//Financial Leasing
		TitleFinancialLeasing: 'HÓA ĐƠN GIÁ TRỊ GIA TĂNG - DỊCH VỤ CHO THUÊ TÀI CHÍNH',
		Expression: 'Bản thể hiện của hóa đơn cho thuê tài chính',
		DecreeNo: 'Hợp đồng cho thuê số',
		DecreeDate: 'Ngày hợp đồng',
		RentalDate: 'Thời gian cho thuê',
		AmountWithoutVatAsset: 'Giá trị tài sản cho thuê chưa có thuế GTGT',
		VATAmountAsset: 'Thuế GTGT của tài sản cho thuê',
		Purchasing: 'Hóa đơn GTGT / Bảng kê',
		ProductAndService: 'Tên hàng hóa, dịch vụ',
		TitleTotalPrice: 'Tiền thuê gồm: + Gốc thuê kỳ :',
		Period: 'Kỳ',
		InterestPeriod: 'Lãi kỳ',
		TotalPrice: 'Số tiền',
		TrincipalMoney: 'Số tiền thuê gốc',
		ProfitMoney: 'Số tiền lãi',
		AmountRelatedFees: 'Phí có liên quan',
		MoreVATAmount: 'Thuế GTGT',
		AmountOverdueInterest: 'Lãi quá hạn và phí khác',
		AmountResidualValue: 'Giá trị còn lại',
		AllTotalAmount: 'Tổng cộng tiền thanh toán',
		WarehouseAddress: 'Địa chỉ (Địa chỉ xuất kho hàng)',
		WarehouseTakeAddress: 'Địa chỉ kho nhận hàng',
		InternalTransferOrder: 'Lệnh điều động nội bộ',
		TotalAmountWithoutVatDisplay: 'Tổng thành tiền chưa trừ chiết khấu',
		TotalAmountWithoutVatDisplay1: 'Tổng thành tiền trước chiết khấu',
		TotalMoney: 'Tổng tiền hàng',
		TotalFeesAmount: 'Tiền phí, lệ phí',

		//SeaFee
		TitleSeaFee: 'BIÊN LAI THU PHÍ, LỆ PHÍ HÀNG HẢI',
		ExpressionSeaFee: 'Bản thể hiện của biên lai thu phí, lệ phí hàng hải',
		ShipName: 'Tên tàu',
		ShipFlag: 'Quốc tịch',
		Callsign: 'Hô hiệu',
		CusName: 'Đại lý',
		AuthorShip: 'Chủ tàu hoặc chủ hàng',
		ShipLOA: 'Cảng đến',
		Berth: 'Cảng rời',
		NextPort: 'Cảng tiếp theo',
		ArrivalDate: 'Ngày đến',
		DepatureDate: 'Ngày rời',
		ShipProduct: 'Hàng hóa xếp, dỡ',
		Costs: 'Các khoản phí',
		AuthorShipSign: 'Chủ tàu, chủ hàng hoặc đại diện',
		ReceiptMaker: 'Người lập biên lai',
		President: 'Giám đốc',

		//template water bd
		CustomerName: 'Tên khách hàng',
		BuyerCode: 'Mã khách hàng',
		BuyerArea: 'Khu vực',
		BuyerBook: 'Sổ ghi',
		InvoiceProid: 'Kỳ hóa đơn',
		ClockStatus: 'Tình trạng đồng hồ',
		MeterReadingFactor: 'Số hộ',
		MeterReadingPrevIndex: 'Chỉ số cũ',
		MeterReadingRemoveIndex: 'Chỉ số tháo',
		MeterReadingMountIndex: 'Chỉ số lắp',
		MeterReadingCurrentIndex: 'Chỉ số mới',
		WaterUsed: 'KL nước tiêu thụ (m3)',
		Normal: 'Bình thường',

		Classify: 'Phân loại',
		Consume: 'Tiêu thụ',
		AddPriceWater: 'Cộng tiền nước',
		UnitMoney: 'Đồng',
		VATForWater: 'Thuế GTGT đối với nước',
		PriceWater: 'Tiền nước',
		PriceWaterOther: 'Tiền DVTN và XLNT',
		VATForPriceWaterOther: 'Thuế GTGT đối với DVTN và XLNT',
		PriceWater2: 'Tiền DVTN',
		PriceWater3: 'Phí BVMT',
		TotalPriceWater: 'Tổng tiền thanh toán',
		AccountNumber: 'Số tài khoản',
		UploadFilePdf: 'Chọn file PDF, ảnh để tải lên',
		UploadFileXml: 'Chọn file *xml, *inv để tải lên',
		Number: 'Số',
		ItemInfo: 'Hàng hóa, dịch vụ',
		ItemPromotion: 'Khuyến mại',
		ItemDiscount: 'Chiết khấu thương mại',
		ItemNoted: 'Ghi chú/diễn giải',
		BuyerFullName1: 'Người mua hàng',
		TotalReductionNotTax: 'Tổng giảm trừ không chịu thuế',
		TotalReductionOther: 'Tổng giảm trừ khác',
		LicensePlate: 'Biển số xe',
		ContractSaleTransferNumber: 'Hợp đồng bán/chuyển nhượng số',
		ItemSpecificProduct: 'Hàng hóa đặc trưng'
	},
	//Bổ sung
	ViewDetailInvoiceOrReceipt: isReceipt => 'Xem chi tiết ' + (!isReceipt ? 'hóa đơn' : 'biên lai'),
	ConfirmDeleteNumberInvoiceSelect: number =>
		`Bạn có chắc chắn muốn xóa ` + (number > 1 ? 'các' : '') + ` hóa đơn đã chọn không?`,

	//NVNAM3: 1/5/2023
	EmailTakeInvoice: 'Email nhận hóa đơn',
	Payment: 'Thanh toán',
	Synthetic: 'Tổng hợp',
	AcceptAdditional: 'Chấp nhận bổ sung',
	AddressAccept: 'Địa chỉ chấp nhận',
	CompanyNameAccept: 'Tên công ty chấp nhận',
	AcceptAdditionalBuyer: 'Chấp nhận bổ sung người mua',
	AcceptAdditionalSeller: 'Chấp nhận bổ sung người bán',
	AcceptAdditionalValid: 'Chấp nhận hợp lệ',
	NotGetData: 'Không lấy được thông tin',

	PaymentInvoice: {
		MarkPaymentTitle: 'Đánh dấu thanh toán',
		PayerName: 'Người thanh toán',
		PaymentDate: 'Ngày thanh toán',
		PaymentAmount: 'Tiền thanh toán',
		PaymentNumber: 'Số lần thanh toán'
	},
	HistoryChecking: {
		TThaiHDonGoc: 'Hóa đơn mới',
		TThaiHDonThayThe: 'Hóa đơn thay thế',
		TThaiHDonDieuChinh: 'Hóa đơn điều chỉnh',
		TThaiHDonDaThayThe: 'Hóa đơn bị thay thế',
		TThaiHDonDaDieuChinh: 'Hóa đơn bị điều chỉnh',
		TThaiHDonXoa: 'Hóa đơn xóa bỏ/hủy bỏ',
		TThaiHDonUnknown: 'Hóa đơn chưa xác định',
		HistoryChange: 'Lịch sử thay đổi kết quả',
		FirstInfo: 'Thông tin ban đầu',
		ChangeInfo: 'Thông tin thay đổi'
	},

	CheckingResult: {
		CheckingAdvance: 'Kiểm tra nâng cao',
		InvoiceName: 'Tên',
		InvoiceNameAccept: 'Tên hóa đơn',
		SignatureDate: 'Ngày ký',
		IssueDate: 'Ngày cấp mã',
		CcyCode: 'Đơn vị tiền tệ',
		ExchangeRate: 'Tỷ giá',
		CheckDate: date => `Kết quả kiểm tra tại ngày ${date}`,
		InvoiceNameInvalid: 'Sai tên hóa đơn',
		InvoiceNameValid: 'Đúng tên hóa đơn',
		InvoiceNoInvalid: 'Số hóa đơn vượt quá 8 chữ số',
		SignatureDateOtherInvoiceDate: 'Ngày ký số khác ngày hóa đơn',
		SignatureDateDiffInvoiceDate: 'Ngày ký số lệch với ngày hóa đơn nhiều hơn 1 ngày',
		CommodityInfo: 'Thông tin hàng hóa',
		PaymentInfo: 'Thông tin thanh toán',
		SpecicalItem: 'Hàng hóa đặc trưng',
		RelativeInvoiceReplaced: 'Thông tin hóa đơn bị thay thế',
		RelativeInvoiceAdjusted: 'Thông tin hóa đơn bị điều chỉnh',
		RelativeReceiptReplaced: 'Thông tin biên lai bị thay thế',
		RelativeReceiptAdjusted: 'Thông tin biên lai bị điều chỉnh',
		BackUIPrevios: 'Quay lại giao diện cũ',
		GenneralInfo: 'Thông tin chung',
		AdvanceStatusOther: 'Một số tiêu chí không hợp lệ khác',
		TooltipInvalidSeries: (series, year, isReceipt = false) =>
			`Ký tự ${series} lệch so với năm lập ${isReceipt ? 'biên lai' : 'hóa đơn'} là ${year}`,
		TootltipInvalidExchangeRate: 'Tỷ giá phải > 0, ≠ 1',
		TootltipInvalidExchangeRate1: 'Tỷ giá của tiền VND phải bằng 1',
		ExchangeRateAccepted: 'Tỷ giá đã được chấp nhận hợp lệ',
		TooltipStatusInvoice: listDecree =>
			`Cách xử lý hóa đơn sai sót không đúng quy định. Quy định tại ${listDecree} không còn nghiệp vụ Hủy hóa đơn`,

		Item: {
			MissingCommodity: 'Thiếu thông tin hàng hóa',
			EnoughCommodity: 'Đủ thông tin hàng hóa',
			Nature: 'Tính chất hàng hóa dịch vụ',
			InvoiceName: 'Tên hàng hóa',
			UnitName: 'Đơn vị tính',
			UnitPrice: 'Đơn giá',
			Quantity: 'Số lượng',
			TotalAmount: 'Thành tiền của Hàng hóa, dịch vụ, Chiết khấu thương mại',
			VatRate: 'Thuế suất với dòng hàng hóa dịch vụ hoặc chiết khấu thương mại.',
			VehicleFrameNumber: 'Số khung',
			VehicleEngineNumber: 'Số máy',
			AssetType: 'Loại tài sản',
			AssetInfo: 'Tình trạng tài sản',
			OriginType: 'Xuất xứ',
			QualityCertNo: 'Số giấy chứng nhận ATKT & BVMT',
			OriginCountryCode: 'Mã nước sản xuất',
			RegistrationTypeName: 'Tên loại tài sản đăng ký',
			ProductionYear: 'Năm sản xuất',
			CommercialName: 'Tên thương mại',
			BrandName: 'Tên nhãn hiệu',
			VehicleKind: 'Kiểu loại xe',
			DisplacementOrPower: 'Thể tích làm việc hoặc Công suất',
			LoadCapacity: 'Trọng tải',
			PermittedSeats: 'Số người cho phép chở',
			PlateNumber: 'Số biển kiểm soát',
			VehicleAssetType: 'Loại tài sản',
			VehicleAssetStatus: 'Tình trạng tài sản',
			VehicleOrigin: 'Xuất xứ',
			VehicleCertificateNumber: 'Số giấy chứng nhận ATKT & BVMT',
			VehicleFactoryInspectionSerial: 'Số seri Phiếu KTCL xuất xưởng',
			ManufacturingCountryCode: 'Mã nước sản xuất',
			RegisteredAssetTypeName: 'Tên loại tài sản đăng ký',
			ManufacturingYear: 'Năm sản xuất',
			CommercialName: 'Tên thương mại',
			BrandName: 'Tên nhãn hiệu',
			VehicleModel: 'Kiểu loại xe',
			VehicleEngineCapacityWork: 'Thể tích làm việc hoặc Công suất',
			VehicleTonnage: 'Trọng tải',
			VehicleSeatingCapacity: 'Số người cho phép chở',
			LicensePlate: 'Biển kiểm soát',
			GoodsTransportName: 'Tên hàng hóa vận chuyển',
			DeparturePlace: 'Điểm đi',
			ArrivalPlace: 'Điểm đến',
			LandParcel: 'Thửa đất',
			AttachedAssetToLand: 'Tài sản gắn liền với đất',
			VehicleAssetTypeCar: 'Ô tô',
			VehicleAssetTypeMotorcycle: 'Mô tô xe máy',
			VehicleAssetStatusUnused: 'Chưa qua sử dụng',
			VehicleAssetStatusUsed: 'Đã qua sử dụng',
			VehicleOriginDomestic: 'Sản xuất, lắp ráp trong nước',
			VehicleOriginImported: 'Nhập khẩu',
			TransportLicensePlate: 'Biển kiểm soát',
			ShipperInfo: 'Tên/Địa chỉ/MST/Số định danh người gửi',
			BKSPTVChuyen: 'Biển kiểm soát phương tiện vận chuyển ',
			MissedItemName: 'Thiếu tên hàng hóa, dịch vụ',
			ValidItemName: 'Đủ tên hàng hóa, dịch vụ',
			TooltipMissedItemName: 'Thiếu tên hàng hóa, dịch vụ theo quy định tại',
			TooltipValidItemName: 'Đủ tên hàng hóa, dịch vụ theo quy định tại',
			MissedReceiptName: 'Thiếu tên loại phí',
			ValidReceiptName: 'Đủ tên loại phí',
			TooltipMissedReceiptName: `Thiếu tên loại phí theo quy định tại`,
			TooltipValidReceiptName: `Đủ tên loại phí theo quy định tại`,
			MissedUnitName: 'Thiếu đơn vị tính',
			ValidUnitName: 'Đủ đơn vị tính',
			AcceptedUnitName: 'Chấp nhận thiếu đơn vị tính',
			TooltipMissedUnitName: 'Thiếu đơn vị tính theo quy định',
			TooltipValidUnitName: 'Đủ đơn vị tính theo quy định',
			MissedQuantity: 'Thiếu thông tin số lượng',
			ValidQuantity: 'Đủ thông tin số lượng',
			AcceptedQuantity: 'Chấp nhận thiếu thông tin số lượng',
			TooltipMissedQuantity: 'Thiếu thông tin số lượng theo quy định',
			TooltipValidQuantity: 'Đủ thông tin số lượng theo quy định',
			MissedUnitPrice: 'Thiếu thông tin đơn giá',
			ValidUnitPrice: 'Đủ thông tin đơn giá',
			AcceptedUnitPrice: 'Chấp nhận thiếu thông tin đơn giá',
			TooltipMissedUnitPrice: 'Thiếu thông tin đơn giá theo quy định',
			TooltipValidUnitPrice: 'Đủ thông tin đơn giá theo quy định',
			MissedTotalAmount: 'Thiếu thông tin thành tiền chi tiết',
			ValidTotalAmount: 'Đủ thông tin thành tiền chi tiết',
			TooltipMissedTotalAmount:
				'Thiếu thông tin thành tiền (chưa bao gồm thuế GTGT) trên ít nhất một dòng Hàng hóa, dịch vụ theo quy định tại',
			TooltipValidTotalAmount:
				'Đủ thông tin thành tiền (chưa bao gồm thuế GTGT) trên các dòng Hàng hóa, dịch vụ theo quy định tại',
			TooltipMissedTotalAmountInvoiceSale:
				'Thiếu thông tin thành tiền trên ít nhất một dòng Hàng hóa, dịch vụ theo quy định tại',
			TooltipValidTotalAmountInvoiceSale:
				'Đủ thông tin thành tiền trên các dòng Hàng hóa, dịch vụ theo quy định tại',
			MissedReceiptAmount: 'Thiếu thông tin tiền phí chi tiết',
			ValidReceiptAmount: 'Đủ thông tin tiền phí chi tiết',
			TooltipMissedReceiptAmount:
				'Thiếu thông tin thành tiền trên ít nhất một dòng Hàng hóa, dịch vụ theo quy định tại',
			TooltipValidReceiptAmount:
				'Đủ thông tin thành tiền trên ít nhất một dòng Hàng hóa, dịch vụ theo quy định tại',

			MissedVatRate: 'Thiếu thông tin thuế suất',
			ValidVatRate: 'Đủ thông tin thuế suất',
			TooltipMissedVatRate: 'Thiếu thông tin thuế suất trên ít nhất một dòng chi tiết theo quy định tại',
			TooltipValidVatRate: 'Đủ thông tin thuế suất trên các dòng chi tiết theo quy định tại',
			ItemIsService: 'Dòng chi tiết là dịch vụ (theo Nghị định 123/2020/NĐ-CP)',
			InvoiceAccordingContract:
				'Hóa đơn cho hoạt động xây dựng, lắp đặt, xây nhà để bán có thu tiền theo tiến độ theo hợp đồng (theo Nghị định 123/2020/NĐ-CP)',
			InvoiceAccordingGovernment:
				'Hóa đơn cho hoạt động xây dựng, lắp đặt, sản xuất, cung cấp sản phẩm, dịch vụ của doanh nghiệp quốc phòng an ninh phục vụ hoạt động quốc phòng an ninh theo quy định của Chính phủ (theo Nghị định 123/2020/NĐ-CP)',
			InvoicePublished: 'Hóa đơn đã phát thành kèm bảng kê liệt kê các hàng hóa, dịch vụ',
			ReasonOther: 'Nguyên nhân khác',
			EnterReason: 'Nhập lý do',
			LackSpecialItem: 'Thiếu loại hàng hóa đặc trưng',
			LackInfoItem: 'Thiếu thông tin của dòng HDDV đặc trưng',
			SpecificItemMissing:
				'Tồn tại dòng có tính chất "5 - Hàng hóa đặc trưng" bị thiếu thông tin loại hàng hóa đặc trưng theo quy định tại',
			VehicleItemMissing:
				'Tồn tại dòng có tính chất "5 - Hàng hóa đặc trưng", loại "1 - Xe ô tô, mô tô" không đủ thông tin Số khung, Số máy, Loại tài sản, Tình trạng tài sản, Xuất xứ, Số Giấy chứng nhận chất lượng an toàn kỹ thuật và bảo vệ môi trường (đối với xe nhập khẩu) hoặc Số seri Phiếu kiểm tra chất lượng xuất xưởng (xe sản xuất, lắp ráp trong nước) theo quy định tại',
			VehicleItemMissing70:
				'Tồn tại dòng có tính chất "5 - Hàng hóa đặc trưng", loại "1 - Xe ô tô, mô tô" không đủ thông tin Số khung, Số máy theo quy định tại',
			TransportItemMissing:
				'Tồn tại dòng có tính chất "5 - Hàng hóa đặc trưng", loại "2 - Dịch vụ vận chuyển" không có thông tin Biển kiểm soát phương tiện vận chuyển theo quy định tại',
			EnoughSpecificInfo: 'Đủ thông tin trên dòng hàng hóa đặc trưng',
			EnoughSpecificDetails:
				'Đủ thông tin đặc trưng trên các dòng có tính chất "5 - Hàng hóa đặc trưng" theo quy định tại',
			AcceptLackSpecificInfoDetail: 'Chấp nhận thiếu thông tin của dòng HHDV đặc trưng',
			AcceptLackSpecificInfo: 'Chấp nhận thiếu loại hàng hóa đặc trưng',
			AcceptMissingTitleButton: 'Chấp nhận thiếu thông tin này',
			SenderName: 'Tên người gửi hàng',
			SenderAddress: 'Địa chỉ người gửi hàng',
			SenderTaxCode: 'MST người gửi hàng',
			SenderIdNumber: 'CCCD chủ hộ người gửi hàng',
			DigitalTransportMissing:
				'Tồn tại dòng có tính chất "5 - Hàng hóa đặc trưng", loại "3 - Dịch vụ vận chuyển trên nền tảng số, TMĐT" không đủ thông tin Tên hàng hóa vận chuyển, Tên người gửi hàng, Địa chỉ người gửi hàng, MST người gửi hàng, Số định danh người gửi hàng theo quy định tại',
			DigitalTransportMissing70:
				'Tồn tại dòng có tính chất "5 - Hàng hóa đặc trưng", loại "3 - Dịch vụ vận chuyển trên nền tảng số, TMĐT" không đủ thông tin Tên người gửi hàng, Địa chỉ người gửi hàng, MST người gửi hàng, Số định danh người gửi hàng theo quy định tại',
			RealEstateMissing:
				'Tồn tại dòng có tính chất "5 - Hàng hóa đặc trưng", loại "4 - Hàng hóa phải đăng ký quyền sử dụng, quyền sở hữu" không có Thông tin thửa đất, Thông tin tài sản gắn liền với đất (nếu có) theo quy định tại',
			MissedCharacteristicGoodsEmpty: 'Thiếu loại hàng hóa đặc trưng',
			MissedCharacteristicGoods: 'Thiếu thông tin của dòng HHDV đặc trưng'
		},
		InvoiceRelated: {
			MissedNatureInfo: 'Thiếu tính chất hóa đơn',
			WrongNatureInfo: 'Sai tính chất hóa đơn',
			MissedInvoiceReplaced: 'Thiếu loại hóa đơn bị thay thế',
			MissedInvoiceAdjusted: 'Thiếu loại hóa đơn bị điều chỉnh',
			WrongInvoiceReplaced: 'Sai loại hóa đơn bị thay thế',
			WrongInvoiceAdjusted: 'Sai loại hóa đơn bị điều chỉnh',
			MissedReceiptReplaced: 'Thiếu loại biên lai bị thay thế',
			MissedReceiptAdjusted: 'Thiếu loại biên lai bị điều chỉnh',
			WrongReceiptReplaced: 'Sai loại biên lai bị thay thế',
			WrongReceiptAdjusted: 'Sai loại biên lai bị điều chỉnh',
			HasTypeReplaced: 'Có loại thông tin bị thay thế',
			HasTypeAdjusted: 'Có loại thông tin bị điều chỉnh',
			MissedTemplateNo: 'Thiếu mẫu số',
			MissedSeries: 'Thiếu ký hiệu',
			MissedInvoiceNo: 'Thiếu số hóa đơn',
			MissedStatementNo: 'Thiếu số bảng kê',
			MissedStatementDate: 'Thiếu ngày bảng kê',
			MissedInvoiceDate: 'Thiếu ngày hóa đơn',
			MissedTemplateNo2: 'Thiếu mẫu số của hóa đơn liên quan',
			MissedSeries2: 'Thiếu ký hiệu của hóa đơn liên quan',
			MissedInvoiceNo2: 'Thiếu số hóa đơn của hóa đơn liên quan',
			MissedInvoiceDate2: 'Thiếu ngày hóa đơn của hóa đơn liên quan',
			MissedTemplateNoReceipt2: 'Thiếu mẫu số của biên lai liên quan',
			MissedSeriesReceipt2: 'Thiếu ký hiệu của biên lai liên quan',
			MissedInvoiceNoReceipt2: 'Thiếu số biên lai của biên lai liên quan',
			MissedInvoiceDateReceipt2: 'Thiếu ngày biên lai của biên lai liên quan',
			TooltipTemplateNoReplaced: 'Thiếu mẫu số của hóa đơn bị thay thế theo quy định tại',
			TooltipTemplateNoAdjusted: 'Thiếu mẫu số của hóa đơn bị điều chỉnh theo quy định tại',
			TooltipInvoiceNoReplaced: 'Thiếu số hóa đơn của hóa đơn bị thay thế theo quy định tại',
			TooltipInvoiceNoAdjusted: 'Thiếu số hóa đơn của hóa đơn bị điều chỉnh theo quy định tại',
			TooltipStatementNoReplaced: 'Thiếu số bảng kê của hóa đơn bị thay thế theo quy định tại',
			TooltipStatementNoAdjusted: 'Thiếu số bảng kê của hóa đơn bị điều chỉnh theo quy định tại',
			TooltipStatementDateReplaced: 'Thiếu ngày bảng kê của hóa đơn bị thay thế theo quy định tại',
			TooltipStatementDateAdjusted: 'Thiếu ngày bảng kê của hóa đơn bị điều chỉnh theo quy định tại',
			TooltipSeriesReplaced: 'Thiếu ký hiệu của hóa đơn bị thay thế theo quy định tại',
			TooltipSeriesAdjusted: 'Thiếu ký hiệu của hóa đơn bị điều chỉnh theo quy định tại',
			TooltipInvoiceDateReplaced: 'Thiếu ngày hóa đơn của hóa đơn bị thay thế theo quy định tại',
			TooltipInvoiceDateAdjusted: 'Thiếu ngày hóa đơn của hóa đơn bị điều chỉnh theo quy định tại',
			TooltipReceiptNoReplaced: 'Thiếu số biên lai của biên lai bị thay thế theo quy định tại',
			TooltipReceiptNoAdjusted: 'Thiếu số biên lai của biên lai bị điều chỉnh theo quy định tại',
			MissedReceiptNo: 'Thiếu số biên lai',
			TooltipReceiptDateReplaced: 'Thiếu ngày biên lai của biên lai bị thay thế theo quy định tại',
			TooltipReceiptDateAdjusted: 'Thiếu ngày biên lai của biên lai bị điều chỉnh theo quy định tại',
			MissedReceiptDate: 'Thiếu ngày biên lai',
			TooltipReceiptTemplateNoReplaced: 'Thiếu mẫu số của biên lai bị thay thế theo quy định tại',
			TooltipReceiptTemplateNoAdjusted: 'Thiếu mẫu số của biên lai bị điều chỉnh theo quy định tại',
			MissedReceiptTemplateNo: 'Thiếu mẫu số của biên lai',
			TooltipReceiptSeriesReplaced: 'Thiếu ký hiệu của biên lai bị thay thế theo quy định tại',
			TooltipReceiptSeriesAdjusted: 'Thiếu ký hiệu của biên lai bị điều chỉnh theo quy định tại',
			MissedReceiptSeries: 'Thiếu ký hiệu của biên lai',
			MSTCLQuan: 'Mã số thuế có liên quan',
			ReasonReplaced: 'Lý do thay thế',
			ReasonAdjusted: 'Lý do điều chỉnh',
			TooltipReason: 'Lý do điều chỉnh/thay thế là "{name}" theo quy định tại Quyết định 1233/QĐ-CT',
			Reason1:
				'Điều chỉnh giá trị quyết toán dự án đầu tư khi có sự thay đổi về đơn giá, khối lượng; điều chỉnh giá bán theo quy định của pháp luật chuyên ngành',
			Reason2:
				'Điều chỉnh giá trị, khối lượng trên cơ sở kết luận của cơ quan nhà nước có thẩm quyền theo quy định của pháp luật có liên quan',
			Reason3:
				'Điều chỉnh giá bán buôn điện giữa Tập đoàn Điện lực Việt Nam với các Tổng công ty Điện lực và giữa các Tổng công ty Điện lực với các Công ty Điện lực',
			Reason4: 'Điều chỉnh do chiết khấu thương mại',
			Reason5:
				'Điều chỉnh do trả lại hàng hóa không phải là tài sản thuộc diện phải đăng ký quyền sử dụng, quyền sở hữu theo quy định của pháp luật và tài sản đã được đăng ký theo tên người mua',
			Reason6:
				'Thay thế do trả lại hàng hóa là tài sản thuộc diện phải đăng ký quyền sử dụng, quyền sở hữu theo quy định của pháp luật và tài sản đã được đăng ký theo tên người mua',
			Reason7:
				'Điều chỉnh do hoàn phí, giảm phí, giảm hoa hồng môi giới bảo hiểm và các khoản chi để giảm thu khác theo quy định của pháp luật kinh doanh bảo hiểm',
			Reason8:
				'Điều chỉnh do huỷ hoặc chấm dứt giao dịch và hủy một phần việc cung cấp dịch vụ khi thu tiền trước cho nhiều kỳ',
			Reason9:
				'Điều chỉnh do hoàn phí của tổ chức tín dụng, tổ chức cung ứng dịch vụ thanh toán không dùng tiền mặt khi thực hiện hoạt động ngân hàng, cung ứng dịch vụ thanh toán không dùng tiền mặt đã lập hóa đơn thu phí dịch vụ',
			Reason10:
				'Điều chỉnh đối với dịch vụ viễn thông mà khách hàng sử dụng thẻ trả trước dịch vụ viễn thông di động để thanh toán cho cước dịch vụ trả sau, nhắn tin ủng hộ từ thiện, các dịch vụ viễn thông khác được chấp nhận thanh toán bằng thẻ trả trước dịch vụ viễn thông di động theo quy định của pháp luật và khi bán thẻ cào, hoàn thành cung cấp dịch vụ doanh nghiệp viễn thông',
			Reason11:
				'Điều chỉnh do có sự thay đổi về giá trị bán khí thiên nhiên thực tế do phải quy đổi ra Việt Nam đồng khi thanh toán thực tế',
			Reason12: 'Điều chỉnh đối với hóa đơn đổi, hoàn chứng từ vận chuyển hàng không.',
			Reason13: 'Điều chỉnh/thay thế cho hóa đơn đã lập sai',
			Reason14: 'Thay thế hóa đơn điện tử đã lập sai là hóa đơn điện tử từ máy tính tiền'
		},
		Payment: {
			InvalidVatRate: 'Thiếu thông tin tổng hợp theo mức thuế suất',
			InvalidTooltipVatRate:
				'Thiếu thông tin Tổng thành tiền (chưa có thuế GTGT), Tổng tiền thuế của từng mức thuế suất theo quy định tại',
			ValidVatRate: 'Đủ thông tin tổng hợp theo mức thuế suất',
			ValidTooltipVatRate: 'Đủ thuế suất trên các dòng chi tiết theo quy định tại',
			InvalidTotalAmountNumber: 'Thiếu tổng tiền thanh toán bằng số',
			InvalidTooltipTotalAmountNumber: 'Thiếu tổng tiền thanh toán bằng số theo quy định tại',
			ValidTotalAmountNumber: 'Đủ tổng tiền thanh toán bằng số',
			ValidTooltipTotalAmountNumber: 'Đủ tổng tiền thanh toán bằng số theo quy định tại',
			NegativeTotalAmountNumberTooltip: (statusInvoiceText, listDecree) =>
				`Tổng tiền thanh toán âm với ${statusInvoiceText}. Theo quy định tại ${listDecree}, chỉ hóa đơn mới dùng để quyết toán hoặc hóa đơn điều chỉnh có thể ghi âm`,
			NegativeTotalAmountNumber: 'Tổng tiền thanh toán âm',
			InvalidTotalAmountWord: 'Thiếu tổng tiền thanh toán bằng chữ',
			InvalidTooltipTotalAmountWord: 'Thiếu tổng tiền thanh toán bằng chữ theo quy định tại',
			ValidTotalAmountWord: 'Đủ tổng tiền thanh toán bằng chữ',
			ValidTooltipTotalAmountWord: 'Đủ tổng tiền thanh toán bằng chữ theo quy định tại',
			ValidFee: 'Có phí, lệ phí thuộc ngân sách nhà nước',
			ValidTooltipFee: text =>
				`Nếu ${text} không phải phí, lệ phí thuộc ngân sách nhà nước, vui lòng báo người bán kiểm tra lại.`,
			WarningPaymentMethod: textAmount => `Hình thức thanh toán tiền mặt với giá trị ≥ ${textAmount} triệu đồng`,
			WarningPaymentMethodReceipt: (method, textAmount) =>
				`Hình thức thanh toán đang là ${method} ${
					textAmount != '' ? `với biên lai có giá trị từ ${textAmount} triệu đồng trở lên` : ''
				}`,
			VatRateInfo: 'Thông tin tổng hợp theo mức thuế suất',
			VatRateAccepted: 'Chấp nhận đủ thông tin tổng hợp theo mức thuế suất',
			TooltipVatRateAccepted: 'Chấp nhận đủ thông tin tổng hợp theo mức thuế suất theo quy định tại',
			TotalAmountNumber: 'Tổng tiền thanh toán bằng số',
			TotalAmountWords: 'Tổng tiền thanh toán bằng chữ',
			AcceptCompareTotalAmount: 'Chấp nhận lệch tổng tiền',
			InvalidCompareTotalAmount: 'Lệch Tổng tiền bằng chữ với Tổng tiền bằng số',
			ValidCompareTotalAmount: 'Khớp Tổng tiền bằng chữ với Tổng tiền bằng số',
			CompareAmountWordNumber: 'So sánh Số tiền bằng chữ với Số tiền bằng số'
		},
		VatRateInfo: {
			WarningTextAva: number => `Phát hiện ${number} hàng hóa, dịch vụ cần kiểm tra lại thuế suất`,
			TextAva: 'Chưa phát hiện hàng hóa, dịch vụ sai thuế suất'
		},
		Xml: {
			Title: 'XML hóa đơn',
			CheckXmlValid: 'Thông tin trường XML chính xác',
			CheckXmlInValid: 'Thông tin trường XML chưa chính xác',
			CheckXml: 'Thông tin trường XML',
			TargetName: 'Tên chỉ tiêu',
			TagName: 'Tên thẻ',
			MaxLength: 'Độ dài tối đa',
			DataType: 'Kiểu dữ liệu',
			Constraint: 'Ràng buộc',
			CheckingResult: 'Kết quả kiểm tra',
			FormatXmlTitle: 'Định dạng hóa đơn điện tử',
			TagNameWrong: 'Thiếu tên thẻ',
			DataLengthWrong: 'Sai độ dài tối đa',
			DataTypeWrong: 'Sai kiểu dữ liệu'
		},
		CheckLogic: 'Chính xác về tính toán số liệu'
	},
	Service: {
		CheckingResultImprovementNotice:
			'Kết quả kiểm tra đang được kiểm nghiệm và cải tiến liên tục dựa trên quy định mới nhất về',
		CheckingResultImprovementNotice1: ' Luật thuế GTGT',
		Title: 'Kết quả kiểm tra thuế suất',
		InvoiceInformation: 'Thông tin trên hóa đơn',
		SuggestInformation: 'Thông tin gợi ý',
		InvoiceCode: 'Mã',
		InvoiceName: 'Tên hàng hóa dịch vụ',
		InvoiceTaxCode: 'Thuế suất GTGT',
		InvoiceTaxCodeSugget: 'Thuế suất gợi ý',
		InvoiceReliabilitySuggest: 'Mức độ tin cậy',
		LookupTaxreducedItem: 'Tra cứu mặt hàng giảm thuế',
		Correct: 'Chính xác',
		Inspect: 'Xem xét',
		Search: 'Nhập Mã, Tên hàng hóa để tìm kiếm',
		Accept: 'Đã chấp nhận',
		NotSuggestTaxKHAC: 'Chưa hỗ trợ kiểm tra hàng hóa, dịch vụ có thuế suất KHAC',
		SuggestInformationDetail:
			'Thông tin gợi ý thuế suất được xây dựng trên công nghệ AI, có mức độ tin cậy theo từng hàng hóa dịch vụ và mang tính chất tham khảo.',
		SuggestInformationDetail1:
			'Hỗ trợ gia tăng độ chính xác của Thuế suất gợi ý bằng cách nhấn "Chấp nhận thuế suất" và làm theo',
		GuideText: 'hướng dẫn'
	},
	NotedUnknow: 'Không có ghi chú',
	AttachFileV2: 'Thêm tệp',

	GoodsVatRate: {
		TaxRate: 'Thuế suất',
		Code: 'Mã',
		ItemName: 'Tên hàng hóa, dịch vụ',
		TitleDelete: 'Bạn muốn xóa hàng hóa, dịch vụ',
		TextConfirmDeleteGoodsVatRate: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại',
		DeleteSuccess: 'Đã xóa hàng hóa, dịch vụ thành công',
		DeleteFail: 'Xóa hàng hóa, dịch vụ thất bại',
		Title8: 'Thuế suất 8% ngoài thời gian giảm thuế',
		Content8: NQ => `Bạn có chắc chắn chấp nhận thuế suất 8% ngoài thời gian giảm thuế theo ${NQ} không?`,
		NotPermissionEdit: 'Bạn không có quyền sửa thuế suất cho hàng hóa, dịch vụ. Vui lòng liên hệ quản trị viên.',
		NotPermissionDelete: 'Bạn không có quyền xóa cho hàng hóa, dịch vụ. Vui lòng liên hệ quản trị viên.',
		NotPermissionAccept:
			'Bạn không có quyền chấp nhận thuế suất cho hàng hóa, dịch vụ. Vui lòng liên hệ quản trị viên.',
		AcceptVatRate: 'Chấp nhận thuế suất',
		CannotDeleteVatRate: 'Không thể xóa mức thuế suất',
		WarningLeastOne: 'Hàng hóa, dịch vụ phải có ít nhất 1 mức thuế suất',
		TitleOver: 'Vượt quá số dòng cho phép',
		ContentOver: (number, itemName) =>
			`Hàng hóa, dịch vụ <${itemName}> đang có ${number +
				1} dòng thuế suất. Vui lòng chỉ thiết lập tối đa ${number} dòng thuế suất.`,
		ContentConfirmSave:
			'Hệ thống sẽ ưu tiên kiểm tra thuế suất của hóa đơn theo thiết lập tại đây. Hãy đảm bảo thuế suất bạn khai báo là chính xác.'
	},

	AttachFileV2: 'Thêm tệp',
	NonDataAmountNumber: listDecree =>
		`Theo quy định tại ${listDecree} về xml hóa đơn, trường hợp hóa đơn điều chỉnh không làm thay đổi thông tin thanh toán của hóa đơn thì không bắt buộc phải có tổng tiền thanh toán bằng số`,
	ZeroDataAmountText: listDecree =>
		`Theo quy định tại ${listDecree} về xml hóa đơn, trường hợp hóa đơn điều chỉnh không làm thay đổi thông tin thanh toán của hóa đơn thì không bắt buộc phải có tổng tiền thanh toán bằng chữ`,
	Mandatory: 'Bắt buộc',
	NotMandatory: 'Không bắt buộc',
	AvaItemCheck: 'Kiểm tra ngành nghề kinh doanh người bán',
	DetailExplain: 'Giải thích chi tiết',
	BusinessDetail: 'Ngành nghề kinh doanh chi tiết',
	TestVersion: 'Thử nghiệm',
	EnterAnyQuestion: 'Nhập bất kỳ câu hỏi nào...',
	ExploreWithAVA: 'Khám phá cách xử lý cùng MISA AVA',
	InvalidCriteriaList: 'Danh sách tiêu chí không hợp lệ',
	SummaryText: 'Tóm tắt',
	ExplainDetail: 'Giải thích chi tiết',
	ReferenceRegulation: 'Quy định liên quan',
	Instruction: 'Hướng dẫn cách xử lý',
	NotFoundResponseAVA: 'Không tìm thấy câu trả lời.',
	AVACheckQuestionAgain: 'Vui lòng thử lại câu hỏi khác hoặc chat với trợ lý số MISA AVA.',
	NoteForResponseAVA: 'AVA có thể sai sót. Vui lòng kiểm chứng lại thông tin quan trọng.',
	ProcessingResponse: 'Đang thực hiện...',
	SignatureWrong: 'Sai chữ ký điện tử',
	TaxaxionWrong: 'Sai kiểm tra với hệ thống của Cơ quan Thuế',
	CommidityWrong: 'Sai thông tin hàng hóa, dịch vụ',
	GenneralWrong: 'Sai thông tin chung',
	InvoiceRelatedWrong: 'Sai thông tin hóa đơn liên quan',
	PaymentWrong: 'Sai thông tin thanh toán',
	TitleAvaTooltipFirst: `Hóa đơn chứa một số tiêu chí không hợp lệ`,
	ContentAvaTooltipFirst: `Để hạn chế rủi ro về hóa đơn, bạn cần nắm rõ nguyên nhân và cách xử lý đối với các tiêu chí trên.`,
	HasBeenAdjusted: 'Đã bị điều chỉnh',
	HasBeenReplaced: 'Đã bị thay thế',
	HasBeenDeleted: 'Đã bị hủy',
	WarningRemoveCheckinResultOld: {
		Title: 'Thông báo nâng cấp giao diện',
		Content: date =>
			`Từ ngày <span class="font-bold">${date}</span>. Hệ thống sẽ tiến hành nâng cấp giao diện chi tiết hóa đơn thông thường sang <span class="font-bold">giao diện kiểm tra nâng cao</span>.`,
		AfterTimeUpdate: 'Trước thời gian này, các giao diện cũ sẽ vẫn hoạt động bình thường.',
		DetailsOfTheChange: 'Chi tiết về thay đổi giao diện',
		TextWarning: date =>
			`Từ ngày ${date}. Hệ thống sẽ tiến hành nâng cấp giao diện chi tiết hóa đơn thông thường sang giao diện kiểm tra nâng cao.`,
		FindMore: 'Tìm hiểu thêm'
	},

	AvaCheckResult: {
		ExchangeRateValid: 'Tỷ giá đã được chấp nhận hợp lệ',
		InvoiceDateNoInfomation: 'Không có ngày hóa đơn',
		SignatureDateNoInfomation: 'Không có ngày ký',
		CcyCodeNoInfomation: 'Không có đơn vị tiền tệ',
		ExchangeRateNoInfomation: 'Không có tỷ giá',
		InvoiceNoNoInfomation: 'Không có số hóa đơn',
		InvoiceNameNoInfomation: 'Không có tên hóa đơn',
		IssueDateNoInfomation: 'Không có ngày cấp mã'
	},
	NonAffectingCriteria: criteria => `Tiêu chí ${criteria} không ảnh hưởng đến kết quả kiểm tra hợp lệ của hóa đơn`,
	DraftInvoice: 'Hóa đơn nháp',
	Result: 'Kết quả',
	VehicleNo: 'Biển số xe',
	From: 'Điểm đi',
	Destination: 'Điểm đến',
	StoreName: 'Tên cửa hàng',
	StoreCode: 'Mã cửa hàng',
	BusinessLocationCode: 'Mã địa điểm kinh doanh',
	BusinessLocationName: 'Tên địa điểm kinh doanh',
	BusinessLocationAddress: 'Địa chỉ địa điểm kinh doanh',

	// NĐ70 Invoice Nature và Constraint texts
	InvoiceNatureND70: {
		TCHDonConstraint:
			'Bắt buộc (1: Thay thế, 2: Điều chỉnh, 3: Thay thế nhiều HĐ, 4: Điều chỉnh nhiều HĐ, 5: Chiết khấu thương mại)',
		HDCTTChinhConstraint: 'Bắt buộc (0: Không phải HĐ cho thuê tài chính, 1: HĐ cho thuê tài chính)',
		MChangConstraint: 'Không bắt buộc (Mã định danh cửa hàng/chi nhánh)',
		MDVQHNSachConstraint: 'Bắt buộc (nếu có) - Mã đơn vị quan hệ ngân sách 7 ký tự',
		LHHDTrungConstraint: 'Bắt buộc (nếu có) - Loại hàng hóa đặc trưng khi TChat=5'
	},
	SyncAgain: 'Cập nhật tình trạng cấp mã',
	DownloadReport: 'Tải báo cáo',
	DownloadReportForm: 'Hình thức tải báo cáo',
	CertificateOwnerInvalidTooltip: (oldTaxCode, identityCode) =>
		`MST trên chữ ký số (${oldTaxCode}) không khớp với MST người bán trên hóa đơn (${identityCode}). Vui lòng chỉ nhấn "Chấp nhận chữ ký số này" khi chắc chắn thông tin là chính xác.`,
	NoDataList: 'Danh sách không có số liệu.',
	DeleteInvoiceConfirmTitle: 'Bạn muốn xóa hóa đơn'
};